'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var react = require('@chakra-ui/react');
var mergeWith = require('lodash.mergewith');
require('copy-to-clipboard');
require('@emotion/react');
require('react-fast-compare');
var _styled = require('@emotion/styled');
var PropTypes = require('prop-types');
var Select = require('react-select');
var reactHookForm = require('react-hook-form');
var reactPdf = require('react-pdf');
require('react-pdf/dist/esm/Page/AnnotationLayer.css');
var reactTable = require('react-table');
var reactTable$1 = require('@tanstack/react-table');
var yup$1 = require('@hookform/resolvers/yup');
var yup = require('yup');
var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mergeWith__default = /*#__PURE__*/_interopDefaultLegacy(mergeWith);
var _styled__default = /*#__PURE__*/_interopDefaultLegacy(_styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var yup__namespace = /*#__PURE__*/_interopNamespace(yup);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}

process.env.NODE_ENV === 'production';

// Number assertions
function isNumber(value) {
  return typeof value === "number";
}

function isArray(value) {
  return Array.isArray(value);
}

function isFunction$1(value) {
  return typeof value === "function";
} // Generic assertions

function isObject(value) {
  var type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
}

function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
} // Empty assertions
var __DEV__ = process.env.NODE_ENV !== "production";
process.env.NODE_ENV === "test";
/**
 * Get value from a deeply nested object using a string path.
 * Memorizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param fallback  - the fallback value
 */

function get(obj, path, fallback, index) {
  var key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj) break;
    obj = obj[key[index]];
  }
  return obj === undefined ? fallback : obj;
}
var memoize = function memoize(fn) {
  var cache = new WeakMap();
  var memoizedFn = function memoizedFn(obj, path, fallback, index) {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, new Map());
    }
    var map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    var value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);

/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */
function objectFilter(object, fn) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = object[key];
    var shouldPass = fn(value, key, object);
    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var filterUndefined = function filterUndefined(object) {
  return objectFilter(object, function (val) {
    return val !== null && val !== undefined;
  });
};
var objectKeys = function objectKeys(obj) {
  return Object.keys(obj);
};
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(" ");
};

/* eslint-disable no-nested-ternary */
function runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isFunction$1(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
Object.freeze(["base", "sm", "md", "lg", "xl", "2xl"]);

var ColorModeContext = /*#__PURE__*/React__namespace.createContext({});
if (__DEV__) {
  ColorModeContext.displayName = "ColorModeContext";
}

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var isImportant = function isImportant(value) {
  return /!(important)?$/.test(value);
};
var withoutImportant = function withoutImportant(value) {
  return isString(value) ? value.replace(/!(important)?$/, "").trim() : value;
};
var tokenToCSSVar = function tokenToCSSVar(scale, value) {
  return function (theme) {
    var valueStr = String(value);
    var important = isImportant(valueStr);
    var valueWithoutImportant = withoutImportant(valueStr);
    var key = scale ? scale + "." + valueWithoutImportant : valueWithoutImportant;
    var transformed = isObject(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    transformed = withoutImportant(transformed);
    return important ? transformed + " !important" : transformed;
  };
};
function createTransform(options) {
  var scale = options.scale,
    transform = options.transform,
    compose = options.compose;
  var fn = function fn(value, theme) {
    var _transform;
    var _value = tokenToCSSVar(scale, value)(theme);
    var result = (_transform = transform == null ? void 0 : transform(_value, theme)) != null ? _transform : _value;
    if (compose) {
      result = compose(result, theme);
    }
    return result;
  };
  return fn;
}
function toConfig(scale, transform) {
  return function (property) {
    var result = {
      property: property,
      scale: scale
    };
    result.transform = createTransform({
      scale: scale,
      transform: transform
    });
    return result;
  };
}
var getRtl = function getRtl(_ref) {
  var rtl = _ref.rtl,
    ltr = _ref.ltr;
  return function (theme) {
    return theme.direction === "rtl" ? rtl : ltr;
  };
};
function logical(options) {
  var property = options.property,
    scale = options.scale,
    transform = options.transform;
  return {
    scale: scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale: scale,
      compose: transform
    }) : transform
  };
}
var _spaceXTemplate, _spaceYTemplate;

/**
 * The CSS transform order following the upcoming spec from CSSWG
 * translate => rotate => scale => skew
 * @see https://drafts.csswg.org/css-transforms-2/#ctm
 * @see https://www.stefanjudis.com/blog/order-in-css-transformation-transform-functions-vs-individual-transforms/
 */
var transformTemplate = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function getTransformTemplate() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(transformTemplate).join(" ");
}
function getTransformGpuTemplate() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(transformTemplate).join(" ");
}
var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": value,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};
var owlSelector = "& > :not(style) ~ :not(style)";
var spaceXTemplate = (_spaceXTemplate = {}, _spaceXTemplate[owlSelector] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, _spaceXTemplate);
var spaceYTemplate = (_spaceYTemplate = {}, _spaceYTemplate[owlSelector] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, _spaceYTemplate);
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };
  var _super = RegExp.prototype,
    _groups = new WeakMap();
  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);
    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }
  function buildGroups(result, re) {
    var g = _groups.get(re);
    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);
    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);
      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }
    if ("function" == typeof substitution) {
      var _this = this;
      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }
    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}
var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet = new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]);
var trimSpace = function trimSpace(str) {
  return str.trim();
};
function parseGradient(value, theme) {
  var _regex$exec$groups, _regex$exec;
  if (value == null || globalSet.has(value)) return value;
  var regex = /*#__PURE__*/_wrapRegExp(/(^[a-z-A-Z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  });
  var _ref = (_regex$exec$groups = (_regex$exec = regex.exec(value)) == null ? void 0 : _regex$exec.groups) != null ? _regex$exec$groups : {},
    type = _ref.type,
    values = _ref.values;
  if (!type || !values) return value;
  var _type = type.includes("-gradient") ? type : type + "-gradient";
  var _values$split$map$fil = values.split(",").map(trimSpace).filter(Boolean),
    maybeDirection = _values$split$map$fil[0],
    stops = _values$split$map$fil.slice(1);
  if ((stops == null ? void 0 : stops.length) === 0) return value;
  var direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);
  var _values = stops.map(function (stop) {
    // if stop is valid shorthand direction, return it
    if (valueSet.has(stop)) return stop;
    var firstStop = stop.indexOf(" "); // color stop could be `red.200 20%` based on css gradient spec

    var _ref2 = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop],
      _color = _ref2[0],
      _stop = _ref2[1];
    var _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" "); // else, get and transform the color token or css value

    var key = "colors." + _color;
    var color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [color].concat(Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]).join(" ") : color;
  });
  return _type + "(" + _values.join(", ") + ")";
}
var isCSSFunction = function isCSSFunction(value) {
  return isString(value) && value.includes("(") && value.includes(")");
};
var gradientTransform = function gradientTransform(value, theme) {
  return parseGradient(value, theme != null ? theme : {});
};
var analyzeCSSValue = function analyzeCSSValue(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
};
var wrap = function wrap(str) {
  return function (value) {
    return str + "(" + value + ")";
  };
};
var transformFunctions = {
  filter: function filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter: function backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring: function ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip: function bgClip(value) {
    return value === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: value
    };
  },
  transform: function transform(value) {
    if (value === "auto") return getTransformTemplate();
    if (value === "auto-gpu") return getTransformGpuTemplate();
    return value;
  },
  px: function px(value) {
    if (value == null) return value;
    var _analyzeCSSValue = analyzeCSSValue(value),
      unitless = _analyzeCSSValue.unitless;
    return unitless || isNumber(value) ? value + "px" : value;
  },
  fraction: function fraction(value) {
    return !isNumber(value) || value > 1 ? value : value * 100 + "%";
  },
  "float": function float(value, theme) {
    var map = {
      left: "right",
      right: "left"
    };
    return theme.direction === "rtl" ? map[value] : value;
  },
  degree: function degree(value) {
    if (isCssVar(value) || value == null) return value;
    var unitless = isString(value) && !value.endsWith("deg");
    return isNumber(value) || unitless ? value + "deg" : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage: function bgImage(value) {
    if (value == null) return value;
    var prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? "url(" + value + ")" : value;
  },
  outline: function outline(value) {
    var isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: value
    };
  },
  flexDirection: function flexDirection(value) {
    var _value;
    var _ref = (_value = flexDirectionTemplate[value]) != null ? _value : {},
      space = _ref.space,
      divide = _ref.divide;
    var result = {
      flexDirection: value
    };
    if (space) result[space] = 1;
    if (divide) result[divide] = 1;
    return result;
  }
};
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", transformFunctions.px),
  spaceT: toConfig("space", transformFunctions.px),
  degreeT: function degreeT(property) {
    return {
      property: property,
      transform: transformFunctions.degree
    };
  },
  prop: function prop(property, scale, transform) {
    return _extends$1({
      property: property,
      scale: scale
    }, scale && {
      transform: createTransform({
        scale: scale,
        transform: transform
      })
    });
  },
  propT: function propT(property, transform) {
    return {
      property: property,
      transform: transform
    };
  },
  sizes: toConfig("sizes", transformFunctions.px),
  sizesT: toConfig("sizes", transformFunctions.fraction),
  shadows: toConfig("shadows"),
  logical: logical,
  blur: toConfig("blur", transformFunctions.blur)
};
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.propT("backgroundImage", transformFunctions.bgImage),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: {
    transform: transformFunctions.bgClip
  },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.propT("backgroundImage", transformFunctions.gradient),
  bgClip: {
    transform: transformFunctions.bgClip
  }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});
/**
 * The prop types for border properties listed above
 */

var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};
var effect = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect, {
  shadow: effect.boxShadow
});
/**
 * Types for box and text shadow properties
 */

var filter = {
  filter: {
    transform: transformFunctions.filter
  },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: {
    transform: transformFunctions.backdropFilter
  },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT("--chakra-backdrop-brightness", transformFunctions.brightness),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: {
    transform: transformFunctions.flexDirection
  },
  experimental_spaceX: {
    "static": spaceXTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform(value) {
        return value !== null ? {
          "--chakra-space-x": value
        } : null;
      }
    })
  },
  experimental_spaceY: {
    "static": spaceYTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform(value) {
        return value != null ? {
          "--chakra-space-y": value
        } : null;
      }
    })
  },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: {
    transform: transformFunctions.outline
  },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};
var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  "float": t.propT("float", transformFunctions["float"]),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});
/**
 * Types for layout related CSS properties
 */

var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};
var getWithPriority = function getWithPriority(theme, key, styles) {
  var result = {};
  var obj = memoizedGet(theme, key, {});
  for (var prop in obj) {
    var isInStyles = prop in styles && styles[prop] != null;
    if (!isInStyles) result[prop] = obj[prop];
  }
  return result;
};
var others = {
  srOnly: {
    transform: function transform(value) {
      if (value === true) return srOnly;
      if (value === "focusable") return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, "layerStyles." + value, styles);
    }
  },
  textStyle: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, "textStyles." + value, styles);
    }
  },
  apply: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, value, styles);
    }
  }
};
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});
/**
 * Types for position CSS properties
 */

/**
 * The parser configuration for common outline properties
 */
var ring = {
  ring: {
    transform: transformFunctions.ring
  },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});
/**
 * Types for space related CSS properties
 */

var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};
var transform = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};
var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop("transitionTimingFunction", "transition.easing")
};
var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  noOfLines: {
    "static": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
};
/**
 * Types for typography related CSS properties
 */

var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  // scroll margin
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};

/**
 * Thank you @markdalgleish for this piece of art!
 */

function resolveReference(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpression = function toExpression(operator) {
  for (var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    operands[_key - 1] = arguments[_key];
  }
  return operands.map(resolveReference).join(" " + operator + " ").replace(/calc/g, "");
};
var _add = function add() {
  for (var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operands[_key2] = arguments[_key2];
  }
  return "calc(" + toExpression.apply(void 0, ["+"].concat(operands)) + ")";
};
var _subtract = function subtract() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }
  return "calc(" + toExpression.apply(void 0, ["-"].concat(operands)) + ")";
};
var _multiply = function multiply() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }
  return "calc(" + toExpression.apply(void 0, ["*"].concat(operands)) + ")";
};
var _divide = function divide() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }
  return "calc(" + toExpression.apply(void 0, ["/"].concat(operands)) + ")";
};
var _negate = function negate(x) {
  var value = resolveReference(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
  }
  return _multiply(value, -1);
};
var calc = Object.assign(function (x) {
  return {
    add: function add() {
      for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        operands[_key6] = arguments[_key6];
      }
      return calc(_add.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }
      return calc(_subtract.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }
      return calc(_multiply.apply(void 0, [x].concat(operands)));
    },
    divide: function divide() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }
      return calc(_divide.apply(void 0, [x].concat(operands)));
    },
    negate: function negate() {
      return calc(_negate(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add,
  subtract: _subtract,
  multiply: _multiply,
  divide: _divide,
  negate: _negate
});
var state = {
  hover: function hover(str, post) {
    return str + ":hover " + post + ", " + str + "[data-hover] " + post;
  },
  focus: function focus(str, post) {
    return str + ":focus " + post + ", " + str + "[data-focus] " + post;
  },
  focusVisible: function focusVisible(str, post) {
    return str + ":focus-visible " + post;
  },
  focusWithin: function focusWithin(str, post) {
    return str + ":focus-within " + post;
  },
  active: function active(str, post) {
    return str + ":active " + post + ", " + str + "[data-active] " + post;
  },
  disabled: function disabled(str, post) {
    return str + ":disabled " + post + ", " + str + "[data-disabled] " + post;
  },
  invalid: function invalid(str, post) {
    return str + ":invalid " + post + ", " + str + "[data-invalid] " + post;
  },
  checked: function checked(str, post) {
    return str + ":checked " + post + ", " + str + "[data-checked] " + post;
  },
  indeterminate: function indeterminate(str, post) {
    return str + ":indeterminate " + post + ", " + str + "[aria-checked=mixed] " + post + ", " + str + "[data-indeterminate] " + post;
  },
  readOnly: function readOnly(str, post) {
    return str + ":read-only " + post + ", " + str + "[readonly] " + post + ", " + str + "[data-read-only] " + post;
  },
  expanded: function expanded(str, post) {
    return str + ":read-only " + post + ", " + str + "[aria-expanded=true] " + post + ", " + str + "[data-expanded] " + post;
  },
  placeholderShown: function placeholderShown(str, post) {
    return str + ":placeholder-shown " + post;
  }
};
var toGroup = function toGroup(fn) {
  return merge(function (v) {
    return fn(v, "&");
  }, "[role=group]", "[data-group]", ".group");
};
var toPeer = function toPeer(fn) {
  return merge(function (v) {
    return fn(v, "~ &");
  }, "[data-peer]", ".peer");
};
var merge = function merge(fn) {
  for (var _len = arguments.length, selectors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    selectors[_key - 1] = arguments[_key];
  }
  return selectors.map(fn).join(", ");
};
var pseudoSelectors = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: toGroup(state.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: toPeer(state.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: toGroup(state.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: toPeer(state.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: toGroup(state.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: toPeer(state.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: toGroup(state.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: toPeer(state.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: toGroup(state.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: toPeer(state.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: toGroup(state.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: toPeer(state.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: toGroup(state.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: toPeer(state.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: toGroup(state.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: toPeer(state.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: toPeer(state.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme])," + "[data-theme=dark] &:not([data-theme])," + "&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme])," + "[data-theme=light] &:not([data-theme])," + "&[data-theme=light]"
};
var pseudoPropNames = objectKeys(pseudoSelectors);
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var systemProps = mergeWith__default["default"]({}, background, border, color, flexbox, layout, filter, ring, interactivity, grid, others, position, effect, space, scroll, typography, textDecoration, transform, list, transition);
Object.assign({}, space, layout, flexbox, grid, position);
var propNames = [].concat(objectKeys(systemProps), pseudoPropNames);
var styleProps = _extends$1({}, systemProps, pseudoSelectors);
var isStyleProp = function isStyleProp(prop) {
  return prop in styleProps;
};

/**
 * Expands an array or object syntax responsive style.
 *
 * @example
 * expandResponsive({ mx: [1, 2] })
 * // or
 * expandResponsive({ mx: { base: 1, sm: 2 } })
 *
 * // => { mx: 1, "@media(min-width:<sm>)": { mx: 2 } }
 */

var expandResponsive = function expandResponsive(styles) {
  return function (theme) {
    /**
     * Before any style can be processed, the user needs to call `toCSSVar`
     * which analyzes the theme's breakpoint and appends a `__breakpoints` property
     * to the theme with more details of the breakpoints.
     *
     * To learn more, go here: packages/utils/src/responsive.ts #analyzeBreakpoints
     */
    if (!theme.__breakpoints) return styles;
    var _theme$__breakpoints = theme.__breakpoints,
      isResponsive = _theme$__breakpoints.isResponsive,
      toArrayValue = _theme$__breakpoints.toArrayValue,
      medias = _theme$__breakpoints.media;
    var computedStyles = {};
    for (var key in styles) {
      var value = runIfFn(styles[key], theme);
      if (value == null) continue; // converts the object responsive syntax to array syntax

      value = isObject(value) && isResponsive(value) ? toArrayValue(value) : value;
      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }
      var queries = value.slice(0, medias.length).length;
      for (var index = 0; index < queries; index += 1) {
        var media = medias == null ? void 0 : medias[index];
        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }
        computedStyles[media] = computedStyles[media] || {};
        if (value[index] == null) {
          continue;
        }
        computedStyles[media][key] = value[index];
      }
    }
    return computedStyles;
  };
};
var isCSSVariableTokenValue = function isCSSVariableTokenValue(key, value) {
  return key.startsWith("--") && isString(value) && !isCssVar(value);
};
var resolveTokenValue = function resolveTokenValue(theme, value) {
  var _ref, _getVar2;
  if (value == null) return value;
  var getVar = function getVar(val) {
    var _theme$__cssMap, _theme$__cssMap$val;
    return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.varRef;
  };
  var getValue = function getValue(val) {
    var _getVar;
    return (_getVar = getVar(val)) != null ? _getVar : val;
  };
  var valueSplit = value.split(",").map(function (v) {
    return v.trim();
  });
  var tokenValue = valueSplit[0],
    fallbackValue = valueSplit[1];
  value = (_ref = (_getVar2 = getVar(tokenValue)) != null ? _getVar2 : getValue(fallbackValue)) != null ? _ref : getValue(value);
  return value;
};
function getCss(options) {
  var _options$configs = options.configs,
    configs = _options$configs === void 0 ? {} : _options$configs,
    _options$pseudos = options.pseudos,
    pseudos = _options$pseudos === void 0 ? {} : _options$pseudos,
    theme = options.theme;
  var css = function css(stylesOrFn, nested) {
    if (nested === void 0) {
      nested = false;
    }
    var _styles = runIfFn(stylesOrFn, theme);
    var styles = expandResponsive(_styles)(theme);
    var computedStyles = {};
    for (var key in styles) {
      var _config$transform, _config, _config2, _config3, _config4;
      var valueOrFn = styles[key];
      /**
       * allows the user to pass functional values
       * boxShadow: theme => `0 2px 2px ${theme.colors.red}`
       */

      var value = runIfFn(valueOrFn, theme);
      /**
       * converts pseudo shorthands to valid selector
       * "_hover" => "&:hover"
       */

      if (key in pseudos) {
        key = pseudos[key];
      }
      /**
       * allows the user to use theme tokens in css vars
       * { --banner-height: "sizes.md" } => { --banner-height: "var(--chakra-sizes-md)" }
       *
       * You can also provide fallback values
       * { --banner-height: "sizes.no-exist, 40px" } => { --banner-height: "40px" }
       */

      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme, value);
      }
      var config = configs[key];
      if (config === true) {
        config = {
          property: key
        };
      }
      if (isObject(value)) {
        var _computedStyles$key;
        computedStyles[key] = (_computedStyles$key = computedStyles[key]) != null ? _computedStyles$key : {};
        computedStyles[key] = mergeWith__default["default"]({}, computedStyles[key], css(value, true));
        continue;
      }
      var rawValue = (_config$transform = (_config = config) == null ? void 0 : _config.transform == null ? void 0 : _config.transform(value, theme, _styles)) != null ? _config$transform : value;
      /**
       * Used for `layerStyle`, `textStyle` and `apply`. After getting the
       * styles in the theme, we need to process them since they might
       * contain theme tokens.
       *
       * `processResult` is the config property we pass to `layerStyle`, `textStyle` and `apply`
       */

      rawValue = (_config2 = config) != null && _config2.processResult ? css(rawValue, true) : rawValue;
      /**
       * allows us to define css properties for RTL and LTR.
       *
       * const marginStart = {
       *   property: theme => theme.direction === "rtl" ? "marginRight": "marginLeft",
       * }
       */

      var configProperty = runIfFn((_config3 = config) == null ? void 0 : _config3.property, theme);
      if (!nested && (_config4 = config) != null && _config4["static"]) {
        var staticStyles = runIfFn(config["static"], theme);
        computedStyles = mergeWith__default["default"]({}, computedStyles, staticStyles);
      }
      if (configProperty && Array.isArray(configProperty)) {
        for (var _iterator = _createForOfIteratorHelperLoose(configProperty), _step; !(_step = _iterator()).done;) {
          var property = _step.value;
          computedStyles[property] = rawValue;
        }
        continue;
      }
      if (configProperty) {
        if (configProperty === "&" && isObject(rawValue)) {
          computedStyles = mergeWith__default["default"]({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }
        continue;
      }
      if (isObject(rawValue)) {
        computedStyles = mergeWith__default["default"]({}, computedStyles, rawValue);
        continue;
      }
      computedStyles[key] = rawValue;
    }
    return computedStyles;
  };
  return css;
}
var css = function css(styles) {
  return function (theme) {
    var cssFn = getCss({
      theme: theme,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };
};

/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */
function createContext(options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$strict = _options.strict,
    strict = _options$strict === void 0 ? true : _options$strict,
    _options$errorMessage = _options.errorMessage,
    errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage,
    name = _options.name;
  var Context = /*#__PURE__*/React__namespace.createContext(undefined);
  Context.displayName = name;
  function useContext() {
    var context = React__namespace.useContext(Context);
    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = "ContextError";
      Error.captureStackTrace == null ? void 0 : Error.captureStackTrace(error, useContext);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext, Context];
}

/**
 * @deprecated - Prefer to use `createStylesContext` to provide better error messages
 *
 * @example
 *
 * ```jsx
 * import { createStylesContext } from "@chakra-ui/react"
 *
 * const [StylesProvider, useStyles] = createStylesContext("Component")
 * ```
 */

createContext({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  });
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * List of props for emotion to omit from DOM.
 * It mostly consists of Chakra props
 */

var allPropNames = new Set([].concat(propNames, ["textStyle", "layerStyle", "apply", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
/**
 * htmlWidth and htmlHeight is used in the <Image />
 * component to support the native `width` and `height` attributes
 *
 * https://github.com/chakra-ui/chakra-ui/issues/149
 */

var validHTMLProps = new Set(["htmlWidth", "htmlHeight", "htmlSize"]);
var shouldForwardProp = function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
};
var _excluded$1 = ["theme", "css", "__css", "sx"],
  _excluded2 = ["baseStyle"];

/**
 * Style resolver function that manages how style props are merged
 * in combination with other possible ways of defining styles.
 *
 * For example, take a component defined this way:
 * ```jsx
 * <Box fontSize="24px" sx={{ fontSize: "40px" }}></Box>
 * ```
 *
 * We want to manage the priority of the styles properly to prevent unwanted
 * behaviors. Right now, the `sx` prop has the highest priority so the resolved
 * fontSize will be `40px`
 */
var toCSSObject = function toCSSObject(_ref) {
  var baseStyle = _ref.baseStyle;
  return function (props) {
    props.theme;
    var cssProp = props.css,
      __css = props.__css,
      sx = props.sx,
      rest = _objectWithoutPropertiesLoose$1(props, _excluded$1);
    var styleProps = objectFilter(rest, function (_, prop) {
      return isStyleProp(prop);
    });
    var finalBaseStyle = runIfFn(baseStyle, props);
    var finalStyles = Object.assign({}, __css, finalBaseStyle, filterUndefined(styleProps), sx);
    var computedCSS = css(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};
function styled(component, options) {
  var _ref2 = options != null ? options : {},
    baseStyle = _ref2.baseStyle,
    styledOptions = _objectWithoutPropertiesLoose$1(_ref2, _excluded2);
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  return _styled__default["default"](component, styledOptions)(styleObject);
}

/**
 * All credit goes to Chance (Reach UI), Haz (Reakit) and (fluentui)
 * for creating the base type definitions upon which we improved on
 */
function forwardRef(component) {
  return /*#__PURE__*/React__namespace.forwardRef(component);
}
function factory() {
  var cache = new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, argArray);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded = ["as", "viewBox", "color", "focusable", "children", "className", "__css"];
var fallbackIcon = {
  path: /*#__PURE__*/React__namespace.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
};
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var element = props.as,
    viewBox = props.viewBox,
    _props$color = props.color,
    color = _props$color === void 0 ? "currentColor" : _props$color,
    _props$focusable = props.focusable,
    focusable = _props$focusable === void 0 ? false : _props$focusable,
    children = props.children,
    className = props.className,
    __css = props.__css,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _className = cx("chakra-icon", className);
  var styles = _extends({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: color
  }, __css);
  var shared = {
    ref: ref,
    focusable: focusable,
    className: _className,
    __css: styles
  };
  var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  /**
   * If you're using an icon library like `react-icons`.
   * Note: anyone passing the `as` prop, should manage the `viewBox` from the external component
   */

  if (element && typeof element !== "string") {
    return /*#__PURE__*/React__namespace.createElement(chakra.svg, _extends({
      as: element
    }, shared, rest));
  }
  var _path = children != null ? children : fallbackIcon.path;
  return /*#__PURE__*/React__namespace.createElement(chakra.svg, _extends({
    verticalAlign: "middle",
    viewBox: _viewBox
  }, shared, rest), _path);
});
if (__DEV__) {
  Icon.displayName = "Icon";
}
function createIcon(options) {
  var _options$viewBox = options.viewBox,
    viewBox = _options$viewBox === void 0 ? "0 0 24 24" : _options$viewBox,
    pathDefinition = options.d,
    displayName = options.displayName,
    _options$defaultProps = options.defaultProps,
    defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps;
  var path = React__namespace.Children.toArray(options.path);
  var Comp = /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React__namespace.createElement(Icon, _extends({
      ref: ref,
      viewBox: viewBox
    }, defaultProps, props), path.length ? path : /*#__PURE__*/React__namespace.createElement("path", {
      fill: "currentColor",
      d: pathDefinition
    }));
  });
  if (__DEV__) {
    Comp.displayName = displayName;
  }
  return Comp;
}

createIcon({
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  displayName: "CopyIcon"
});
createIcon({
  d: "M23.384,21.619,16.855,15.09a9.284,9.284,0,1,0-1.768,1.768l6.529,6.529a1.266,1.266,0,0,0,1.768,0A1.251,1.251,0,0,0,23.384,21.619ZM2.75,9.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,2.75,9.5Z",
  displayName: "SearchIcon"
});
createIcon({
  d: "M23.414,20.591l-4.645-4.645a10.256,10.256,0,1,0-2.828,2.829l4.645,4.644a2.025,2.025,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.25,3.005A7.25,7.25,0,1,1,3,10.255,7.258,7.258,0,0,1,10.25,3.005Z",
  displayName: "Search2Icon"
});
createIcon({
  d: "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z",
  displayName: "MoonIcon"
});
createIcon({
  displayName: "SunIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12 1v2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12 21v2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.22 4.22l1.42 1.42"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.36 18.36l1.42 1.42"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1 12h2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21 12h2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.22 19.78l1.42-1.42"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.36 5.64l1.42-1.42"
  }))
});
createIcon({
  d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
  displayName: "AddIcon"
});
createIcon({
  displayName: "SmallAddIcon",
  viewBox: "0 0 20 20",
  path: /*#__PURE__*/React__namespace.createElement("path", {
    fill: "currentColor",
    d: "M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z",
    fillRule: "evenodd"
  })
});
createIcon({
  viewBox: "0 0 14 14",
  d: "M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z",
  displayName: "SettingsIcon"
});
createIcon({
  displayName: "CheckCircleIcon",
  d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
});
createIcon({
  d: "M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z",
  displayName: "LockIcon"
});
createIcon({
  d: "M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z",
  displayName: "UnlockIcon"
});
createIcon({
  displayName: "ViewIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  }))
});
createIcon({
  displayName: "ViewOffIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z"
  }))
});
createIcon({
  d: "M11.2857,6.05714 L10.08571,4.85714 L7.85714,7.14786 L7.85714,1 L6.14286,1 L6.14286,7.14786 L3.91429,4.85714 L2.71429,6.05714 L7,10.42857 L11.2857,6.05714 Z M1,11.2857 L1,13 L13,13 L13,11.2857 L1,11.2857 Z",
  displayName: "DownloadIcon",
  viewBox: "0 0 14 14"
});
createIcon({
  displayName: "DeleteIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.129-.382.5.5 0 00-.369-.163zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zm5 0a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zM22 4h-4.75a.25.25 0 01-.25-.25V2.5A2.5 2.5 0 0014.5 0h-5A2.5 2.5 0 007 2.5v1.25a.25.25 0 01-.25.25H2a1 1 0 000 2h20a1 1 0 000-2zM9 3.75V2.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1.25a.25.25 0 01-.25.25h-5.5A.25.25 0 019 3.75z"
  }))
});
createIcon({
  displayName: "RepeatIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.319,4.936a7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333A7.7,7.7,0,0,1,10.319,4.936Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.406,14.1a.5.5,0,0,0,.015-.526l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253,1.25,1.25,0,1,0-1.872,1.656,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0A.5.5,0,0,0,23.406,14.1Z"
  }))
});
createIcon({
  displayName: "RepeatClockIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z"
  }))
});
createIcon({
  displayName: "EditIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
  }))
});
createIcon({
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
  displayName: "ChevronLeftIcon"
});
var ChevronRightIcon = createIcon({
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
  displayName: "ChevronRightIcon"
});
var ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});
createIcon({
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
  displayName: "ChevronUpIcon"
});
createIcon({
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
  displayName: "ArrowBackIcon"
});
createIcon({
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
  displayName: "ArrowForwardIcon"
});
createIcon({
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z",
  displayName: "ArrowUpIcon"
});
createIcon({
  viewBox: "0 0 16 16",
  d: "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z",
  displayName: "ArrowUpDownIcon"
});
createIcon({
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
  displayName: "ArrowDownIcon"
});
createIcon({
  displayName: "ExternalLinkIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15 3h6v6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10 14L21 3"
  }))
});
createIcon({
  displayName: "LinkIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z"
  }))
});
createIcon({
  displayName: "PlusSquareIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    height: "18",
    width: "18",
    rx: "2",
    ry: "2",
    x: "3",
    y: "3"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12 8v8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8 12h8"
  }))
});
createIcon({
  displayName: "CalendarIcon",
  viewBox: "0 0 14 14",
  d: "M10.8889,5.5 L3.11111,5.5 L3.11111,7.05556 L10.8889,7.05556 L10.8889,5.5 Z M12.4444,1.05556 L11.6667,1.05556 L11.6667,0 L10.1111,0 L10.1111,1.05556 L3.88889,1.05556 L3.88889,0 L2.33333,0 L2.33333,1.05556 L1.55556,1.05556 C0.692222,1.05556 0.00777777,1.75556 0.00777777,2.61111 L0,12.5 C0,13.3556 0.692222,14 1.55556,14 L12.4444,14 C13.3,14 14,13.3556 14,12.5 L14,2.61111 C14,1.75556 13.3,1.05556 12.4444,1.05556 Z M12.4444,12.5 L1.55556,12.5 L1.55556,3.94444 L12.4444,3.94444 L12.4444,12.5 Z M8.55556,8.61111 L3.11111,8.61111 L3.11111,10.1667 L8.55556,10.1667 L8.55556,8.61111 Z"
});
createIcon({
  d: "M0.913134,0.920639 C1.49851,0.331726 2.29348,0 3.12342,0 L10.8766,0 C11.7065,0 12.5015,0.331725 13.0869,0.920639 C13.6721,1.50939 14,2.30689 14,3.13746 L14,8.12943 C13.9962,8.51443 13.9059,8.97125 13.7629,9.32852 C13.6128,9.683 13.3552,10.0709 13.0869,10.3462 C12.813,10.6163 12.4265,10.8761 12.0734,11.0274 C11.7172,11.1716 11.2607,11.263 10.8766,11.2669 L10.1234,11.2669 L10.1234,12.5676 L10.1209,12.5676 C10.1204,12.793 10.0633,13.0791 9.97807,13.262 C9.8627,13.466 9.61158,13.7198 9.40818,13.8382 L9.40824,13.8383 C9.4077,13.8386 9.40716,13.8388 9.40661,13.8391 C9.40621,13.8393 9.4058,13.8396 9.40539,13.8398 L9.40535,13.8397 C9.22958,13.9254 8.94505,13.9951 8.75059,14 L8.74789,14 C8.35724,13.9963 7.98473,13.8383 7.71035,13.5617 L5.39553,11.2669 L3.12342,11.2669 C2.29348,11.2669 1.49851,10.9352 0.913134,10.3462 C0.644826,10.0709 0.387187,9.683 0.23711,9.32852 C0.0941235,8.97125 0.00379528,8.51443 0,8.12943 L0,3.13746 C0,2.30689 0.327915,1.50939 0.913134,0.920639 Z M3.12342,1.59494 C2.71959,1.59494 2.33133,1.75628 2.04431,2.04503 C1.75713,2.33395 1.59494,2.72681 1.59494,3.13746 L1.59494,8.12943 C1.59114,8.35901 1.62114,8.51076 1.71193,8.72129 C1.79563,8.9346 1.88065,9.06264 2.04431,9.22185 C2.33133,9.5106 2.71959,9.67195 3.12342,9.67195 L5.72383,9.67195 C5.93413,9.67195 6.13592,9.75502 6.28527,9.90308 L8.52848,12.1269 L8.52848,10.4694 C8.52848,10.029 8.88552,9.67195 9.32595,9.67195 L10.8766,9.67195 C11.1034,9.67583 11.2517,9.64614 11.4599,9.55518 C11.6712,9.47132 11.7976,9.38635 11.9557,9.22185 C12.1193,9.06264 12.2044,8.9346 12.2881,8.72129 C12.3789,8.51076 12.4089,8.35901 12.4051,8.12943 L12.4051,3.13746 C12.4051,2.72681 12.2429,2.33394 11.9557,2.04503 C11.6687,1.75628 11.2804,1.59494 10.8766,1.59494 L3.12342,1.59494 Z",
  displayName: "ChatIcon",
  viewBox: "0 0 14 14"
});
createIcon({
  displayName: "TimeIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z"
  }))
});
createIcon({
  displayName: "ArrowRightIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.584,12a2.643,2.643,0,0,1-.775,1.875L3.268,23.416a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L.768,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,13.584,12Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.75,12a2.643,2.643,0,0,1-.775,1.875l-9.541,9.541a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L10.934,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,23.75,12Z"
  }))
});
createIcon({
  displayName: "ArrowLeftIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.416,12a2.643,2.643,0,0,1,.775-1.875L20.732.584a1.768,1.768,0,0,1,2.5,2.5l-8.739,8.739a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5l-9.541-9.541A2.643,2.643,0,0,1,10.416,12Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.25,12a2.643,2.643,0,0,1,.775-1.875L10.566.584a1.768,1.768,0,0,1,2.5,2.5L4.327,11.823a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5L1.025,13.875A2.643,2.643,0,0,1,.25,12Z"
  }))
});
createIcon({
  displayName: "AtSignIcon",
  d: "M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z"
});
createIcon({
  displayName: "AttachmentIcon",
  d: "M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z"
});
createIcon({
  displayName: "UpDownIcon",
  viewBox: "-1 -1 9 11",
  d: "M 3.5 0L 3.98809 -0.569442L 3.5 -0.987808L 3.01191 -0.569442L 3.5 0ZM 3.5 9L 3.01191 9.56944L 3.5 9.98781L 3.98809 9.56944L 3.5 9ZM 0.488094 3.56944L 3.98809 0.569442L 3.01191 -0.569442L -0.488094 2.43056L 0.488094 3.56944ZM 3.01191 0.569442L 6.51191 3.56944L 7.48809 2.43056L 3.98809 -0.569442L 3.01191 0.569442ZM -0.488094 6.56944L 3.01191 9.56944L 3.98809 8.43056L 0.488094 5.43056L -0.488094 6.56944ZM 3.98809 9.56944L 7.48809 6.56944L 6.51191 5.43056L 3.01191 8.43056L 3.98809 9.56944Z"
});
createIcon({
  d: "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z",
  displayName: "StarIcon"
});
createIcon({
  displayName: "EmailIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.114,14.556a1.252,1.252,0,0,0,1.768,0L22.568,4.87a.5.5,0,0,0-.281-.849A1.966,1.966,0,0,0,22,4H2a1.966,1.966,0,0,0-.289.021.5.5,0,0,0-.281.849Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.888,5.832a.182.182,0,0,0-.2.039l-6.2,6.2a.251.251,0,0,0,0,.354l5.043,5.043a.75.75,0,1,1-1.06,1.061l-5.043-5.043a.25.25,0,0,0-.354,0l-2.129,2.129a2.75,2.75,0,0,1-3.888,0L7.926,13.488a.251.251,0,0,0-.354,0L2.529,18.531a.75.75,0,0,1-1.06-1.061l5.043-5.043a.251.251,0,0,0,0-.354l-6.2-6.2a.18.18,0,0,0-.2-.039A.182.182,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.181.181,0,0,0,23.888,5.832Z"
  }))
});
createIcon({
  d: "M2.20731,0.0127209 C2.1105,-0.0066419 1.99432,-0.00664663 1.91687,0.032079 C0.871279,0.438698 0.212942,1.92964 0.0580392,2.95587 C-0.426031,6.28627 2.20731,9.17133 4.62766,11.0689 C6.77694,12.7534 10.9012,15.5223 13.3409,12.8503 C13.6507,12.5211 14.0186,12.037 13.9993,11.553 C13.9412,10.7397 13.186,10.1588 12.6051,9.71349 C12.1598,9.38432 11.2304,8.47427 10.6495,8.49363 C10.1267,8.51299 9.79754,9.05515 9.46837,9.38432 L8.88748,9.96521 C8.79067,10.062 7.55145,9.24878 7.41591,9.15197 C6.91248,8.8228 6.4284,8.45491 6.00242,8.04829 C5.57644,7.64167 5.18919,7.19632 4.86002,6.73161 C4.7632,6.59607 3.96933,5.41495 4.04678,5.31813 C4.04678,5.31813 4.72448,4.58234 4.91811,4.2919 C5.32473,3.67229 5.63453,3.18822 5.16982,2.45243 C4.99556,2.18135 4.78257,1.96836 4.55021,1.73601 C4.14359,1.34875 3.73698,0.942131 3.27227,0.612963 C3.02055,0.419335 2.59457,0.0708094 2.20731,0.0127209 Z",
  displayName: "PhoneIcon",
  viewBox: "0 0 14 14"
});
createIcon({
  viewBox: "0 0 10 10",
  d: "M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z",
  displayName: "DragHandleIcon"
});
createIcon({
  displayName: "SpinnerIcon",
  path: /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("linearGradient", {
    x1: "28.154%",
    y1: "63.74%",
    x2: "74.629%",
    y2: "17.783%",
    id: "a"
  }, /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React__namespace.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: "0",
    offset: "100%"
  }))), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(2)",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    stroke: "url(#a)",
    strokeWidth: "4",
    cx: "10",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10 2C4.477 2 0 6.477 0 12",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /*#__PURE__*/React__namespace.createElement("rect", {
    fill: "currentColor",
    x: "8",
    width: "4",
    height: "4",
    rx: "8"
  })))
});
var CloseIcon = createIcon({
  displayName: "CloseIcon",
  d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});
createIcon({
  displayName: "SmallCloseIcon",
  viewBox: "0 0 16 16",
  path: /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 0 0-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L9.41 8z",
    fillRule: "evenodd",
    fill: "currentColor"
  })
});
createIcon({
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z",
  displayName: "NotAllowedIcon"
});
createIcon({
  d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z",
  displayName: "TriangleDownIcon"
});
createIcon({
  d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z",
  displayName: "TriangleUpIcon"
});
createIcon({
  displayName: "InfoOutlineIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "none",
    r: "11",
    stroke: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("line", {
    fill: "none",
    x1: "11.959",
    x2: "11.959",
    y1: "11",
    y2: "17"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    cx: "11.959",
    cy: "7",
    r: "1",
    stroke: "none"
  }))
});
createIcon({
  displayName: "BellIcon",
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
});
createIcon({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
});
createIcon({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z",
  displayName: "QuestionIcon"
});
createIcon({
  displayName: "QuestionOutlineIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  }))
});
createIcon({
  d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z",
  displayName: "WarningIcon"
});
createIcon({
  displayName: "WarningTwoIcon",
  d: "M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z"
});
createIcon({
  viewBox: "0 0 14 14",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("polygon", {
    points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
  }))
});
createIcon({
  displayName: "MinusIcon",
  path: /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    height: "4",
    width: "20",
    x: "2",
    y: "10"
  }))
});
var HamburgerIcon = createIcon({
  displayName: "HamburgerIcon",
  viewBox: "0 0 24 24",
  d: "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"
});

function Topbar(props) {
  const {
    navItems = [],
    btnColor = 'green'
  } = props;
  const {
    isOpen,
    onToggle
  } = react.useDisclosure();
  return /*#__PURE__*/React__default["default"].createElement(react.Box, null, /*#__PURE__*/React__default["default"].createElement(react.ColorModeScript, {
    initialColorMode: react.theme.config.initialColorMode
  }), /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    bg: react.useColorModeValue('white', 'gray.800'),
    color: react.useColorModeValue('gray.600', 'white'),
    minH: '60px',
    py: {
      base: 2
    },
    px: {
      base: 4
    },
    borderBottom: 1,
    borderStyle: 'solid',
    borderColor: react.useColorModeValue('gray.200', 'gray.900'),
    align: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    flex: {
      base: 1,
      md: 'auto'
    },
    ml: {
      base: -2
    },
    display: {
      base: 'flex',
      md: 'none'
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.IconButton, {
    onClick: onToggle,
    icon: isOpen ? /*#__PURE__*/React__default["default"].createElement(CloseIcon, {
      w: 3,
      h: 3
    }) : /*#__PURE__*/React__default["default"].createElement(HamburgerIcon, {
      w: 5,
      h: 5
    }),
    variant: 'ghost',
    "aria-label": 'Toggle Navigation'
  })), /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    flex: {
      base: 1
    },
    justify: {
      base: 'center',
      md: 'start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    textAlign: react.useBreakpointValue({
      base: 'center',
      md: 'left'
    }),
    fontFamily: 'heading',
    color: react.useColorModeValue('gray.800', 'white')
  }, "Logo"), /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    display: {
      base: 'none',
      md: 'flex'
    },
    ml: 10
  }, /*#__PURE__*/React__default["default"].createElement(DesktopNav, {
    navItems: navItems
  }))), /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    flex: {
      base: 1,
      md: 0
    },
    justify: 'flex-end',
    direction: 'row',
    spacing: 6
  }, /*#__PURE__*/React__default["default"].createElement(react.Button, {
    as: 'a',
    fontSize: 'sm',
    fontWeight: 400,
    variant: 'link',
    href: '#'
  }, "Sign In"), /*#__PURE__*/React__default["default"].createElement(react.Button, {
    display: {
      base: 'none',
      md: 'inline-flex'
    },
    fontSize: 'sm',
    fontWeight: 600,
    colorScheme: btnColor,
    href: '#',
    _hover: {
      bg: 'pink.300'
    }
  }, "Sign Up"))), /*#__PURE__*/React__default["default"].createElement(react.Collapse, {
    in: isOpen,
    animateOpacity: true
  }, /*#__PURE__*/React__default["default"].createElement(MobileNav, {
    navItems: navItems
  })));
}
const DesktopNav = props => {
  const linkColor = react.useColorModeValue('gray.600', 'gray.200');
  const linkHoverColor = react.useColorModeValue('gray.800', 'white');
  const popoverContentBgColor = react.useColorModeValue('white', 'gray.800');
  return /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    direction: 'row',
    spacing: 4
  }, props.navItems.map(navItem => /*#__PURE__*/React__default["default"].createElement(react.Box, {
    key: navItem.label
  }, /*#__PURE__*/React__default["default"].createElement(react.Popover, {
    trigger: 'hover',
    placement: 'bottom-start'
  }, /*#__PURE__*/React__default["default"].createElement(react.PopoverTrigger, null, /*#__PURE__*/React__default["default"].createElement(react.Link, {
    p: 2,
    href: navItem.href ?? '#',
    fontSize: 'sm',
    fontWeight: 500,
    color: linkColor,
    _hover: {
      textDecoration: 'none',
      color: linkHoverColor
    }
  }, navItem.label)), navItem.children && /*#__PURE__*/React__default["default"].createElement(react.PopoverContent, {
    border: 0,
    boxShadow: 'xl',
    bg: popoverContentBgColor,
    p: 4,
    rounded: 'xl',
    minW: 'sm'
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, null, navItem.children.map(child => /*#__PURE__*/React__default["default"].createElement(DesktopSubNav, _extends$2({
    key: child.label
  }, child)))))))));
};
const DesktopSubNav = ({
  label,
  href,
  subLabel
}) => {
  return /*#__PURE__*/React__default["default"].createElement(react.Link, {
    href: href,
    role: 'group',
    display: 'block',
    p: 2,
    rounded: 'md',
    _hover: {
      bg: react.useColorModeValue('pink.50', 'gray.900')
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    direction: 'row',
    align: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Box, null, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    transition: 'all .3s ease',
    _groupHover: {
      color: 'pink.400'
    },
    fontWeight: 500
  }, label), /*#__PURE__*/React__default["default"].createElement(react.Text, {
    fontSize: 'sm'
  }, subLabel)), /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    transition: 'all .3s ease',
    transform: 'translateX(-10px)',
    opacity: 0,
    _groupHover: {
      opacity: '100%',
      transform: 'translateX(0)'
    },
    justify: 'flex-end',
    align: 'center',
    flex: 1
  }, /*#__PURE__*/React__default["default"].createElement(react.Icon, {
    color: 'pink.400',
    w: 5,
    h: 5,
    as: ChevronRightIcon
  }))));
};
const MobileNav = props => {
  return /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    bg: react.useColorModeValue('white', 'gray.800'),
    p: 4,
    display: {
      md: 'none'
    }
  }, props.navItems.map(navItem => /*#__PURE__*/React__default["default"].createElement(MobileNavItem, _extends$2({
    key: navItem.label
  }, navItem))));
};
const MobileNavItem = ({
  label,
  children,
  href
}) => {
  const {
    isOpen,
    onToggle
  } = react.useDisclosure();
  return /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    spacing: 4,
    onClick: children && onToggle
  }, /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    py: 2,
    as: react.Link,
    href: href ?? '#',
    justify: 'space-between',
    align: 'center',
    _hover: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    fontWeight: 600,
    color: react.useColorModeValue('gray.600', 'gray.200')
  }, label), children && /*#__PURE__*/React__default["default"].createElement(react.Icon, {
    as: ChevronDownIcon,
    transition: 'all .25s ease-in-out',
    transform: isOpen ? 'rotate(180deg)' : '',
    w: 6,
    h: 6
  })), /*#__PURE__*/React__default["default"].createElement(react.Collapse, {
    in: isOpen,
    animateOpacity: true,
    style: {
      marginTop: '0!important'
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    mt: 2,
    pl: 4,
    borderLeft: 1,
    borderStyle: 'solid',
    borderColor: react.useColorModeValue('gray.200', 'gray.700'),
    align: 'start'
  }, children && children.map(child => /*#__PURE__*/React__default["default"].createElement(react.Link, {
    key: child.label,
    py: 2,
    href: child.href
  }, child.label)))));
};
Topbar.propTypes = {
  navItems: PropTypes__default["default"].array,
  title: PropTypes__default["default"].string
};

function AvatarIcon(props) {
  return /*#__PURE__*/React__default["default"].createElement(react.Wrap, null, /*#__PURE__*/React__default["default"].createElement(react.WrapItem, null, /*#__PURE__*/React__default["default"].createElement(react.Avatar, _extends$2({
    name: props.name,
    src: props.src,
    icon: props.icon
  }, props))));
}
AvatarIcon.propTypes = {
  icon: PropTypes__default["default"].element,
  name: PropTypes__default["default"].string,
  src: PropTypes__default["default"].object
};

const DANGER = '#FF0000';
const GRAY_COLOR = '#E2E8F0';
const WHITE_COLOR = '#FFFFFF';
const SECONDARY = '#023B93';
const MID_NIGHT_BLUE = '#023B93';
const LIGHT_BLUE = '#C2E1EB';
const BLACK = '#000';
const PRIMARY = '#43DAD4';
const LOGINFORMBG = '#F7F7FA';
const HOVER_COLOR = '#77d2d91A';

const customStyles = props => {
  switch (props.variant) {
    case 'primary':
      return {
        control: (base, state) => {
          return {
            ...base,
            borderColor: state.selectProps.errorText ? DANGER : GRAY_COLOR
          };
        },
        option: provided => ({
          ...provided,
          '&:hover': {
            background: HOVER_COLOR,
            color: 'black'
          }
        })
      };
    case 'secondary':
      return {
        control: (base, state) => {
          return {
            ...base,
            borderWidth: 0
          };
        },
        option: provided => ({
          ...provided,
          '&:hover': {
            background: HOVER_COLOR
          }
        })
      };
    case 'advanced':
      return {
        control: (base, state) => ({
          ...base,
          borderWidth: 0,
          borderColor: state.selectProps.errorText ? DANGER : GRAY_COLOR
        }),
        singleValue: props => ({
          ...props
        }),
        placeholder: props => {
          return {
            ...props
          };
        },
        dropdownIndicator: props => ({
          ...props
        }),
        menuList: props => ({
          ...props,
          paddingBottom: 0
        }),
        option: provided => ({
          ...provided,
          '&:hover': {
            background: HOVER_COLOR
          }
        })
      };
    case 'advanced-solid':
      return {
        control: (base, state) => ({
          ...base,
          borderRadius: 20,
          paddingLeft: 10,
          paddingRight: 10,
          backgroundColor: props.color,
          borderColor: state.selectProps.errorText ? DANGER : GRAY_COLOR
        }),
        singleValue: props => ({
          ...props,
          color: props.color ? 'white' : 'black'
        }),
        placeholder: props => {
          return {
            ...props,
            color: props.color ? 'white' : 'black'
          };
        },
        dropdownIndicator: props => ({
          ...props,
          color: props.color ? 'white' : 'black'
        }),
        menuList: props => ({
          ...props,
          paddingBottom: 0
        }),
        option: provided => ({
          ...provided,
          '&:hover': {
            background: HOVER_COLOR
          }
        })
      };
    default:
      return {
        control: (base, state) => ({
          ...base,
          borderColor: state.selectProps.errorText ? DANGER : GRAY_COLOR
        }),
        option: provided => ({
          ...provided,
          '&:hover': {
            background: HOVER_COLOR
          }
        })
      };
  }
};
const AdvancedControlComponent = props => {
  const currentValue = props.getValue();
  return /*#__PURE__*/React__default["default"].createElement(react.HStack, null, props.selectProps.avatar ? /*#__PURE__*/React__default["default"].createElement(react.Avatar, _extends$2({
    name: currentValue?.length && currentValue[0].label,
    bg: props.selectProps.color ? props.selectProps.color : SECONDARY
  }, props.selectProps.avatarProps)) : props.selectProps.customIcon, /*#__PURE__*/React__default["default"].createElement(Select.components.Control, props));
};
const CustomMenuComponent = props => {
  return /*#__PURE__*/React__default["default"].createElement(Select.components.MenuList, props, props.selectProps.menuHeaderComponent && props.selectProps.menuHeaderComponent(), props.children, props.selectProps.menuFooterComponent && props.selectProps.menuFooterComponent());
};
const getComponents = props => {
  switch (props.variant) {
    case 'primary':
      return {
        IndicatorSeparator: null
      };
    case 'secondary':
      return {
        IndicatorSeparator: null,
        MenuList: CustomMenuComponent
      };
    case 'advanced':
      return {
        IndicatorSeparator: null,
        Control: AdvancedControlComponent,
        MenuList: CustomMenuComponent
      };
    case 'advanced-solid':
      return {
        IndicatorSeparator: null,
        MenuList: CustomMenuComponent
      };
    default:
      return {
        IndicatorSeparator: null
      };
  }
};
const CQSelect = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
  const {
    variant,
    options,
    placeholder,
    errorText,
    errorTextStyle
  } = props;
  const errorStyle = errorTextStyle || {};
  const styles = variant ? customStyles(props) : customStyles({
    variant: 'primary'
  });
  const getStyle = styles => {
    if (styles.option) {
      styles.option = (provided, {
        data,
        isFocused
      }) => ({
        ...provided,
        ...styles.option,
        '&:hover': {
          background: HOVER_COLOR,
          color: isFocused ? styles.option.color || 'black' : data.color
        }
      });
    } else {
      styles.option = (provided, {
        data,
        isFocused
      }) => ({
        ...provided,
        '&:hover': {
          background: HOVER_COLOR,
          color: isFocused ? styles.option.color || 'black' : data.color
        }
      });
    }
    return styles;
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Select__default["default"], _extends$2({
    ref: ref,
    options: options,
    placeholder: placeholder,
    components: getComponents(props)
  }, props, {
    styles: props.styles ? getStyle(props.styles) : styles
    // theme={theme => ({
    //   ...theme,
    //   borderRadius: 0,
    //   colors: {
    //     ...theme.colors,
    //     primary25: 'transparent'
    //   }
    // })}
  })), errorText && /*#__PURE__*/React__default["default"].createElement(react.Text, {
    color: DANGER,
    style: {
      ...errorStyle
    }
  }, errorText));
});
const FormCQSelect = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
  const styles = props.variant ? customStyles(props) : customStyles({
    variant: 'primary'
  });
  const controller = reactHookForm.useController({
    control: props.control,
    defaultValue: '',
    name: props.name
  });
  const handleChange = e => {
    if (props.onChange) {
      props.onChange(e);
    }
    controller.field.onChange(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(CQSelect, _extends$2({
    ref: ref,
    options: props.options,
    placeholder: props.placeholder,
    components: getComponents(props),
    styles: styles,
    onChange: handleChange,
    errorText: controller.fieldState?.error?.message
  }, props)));
});
CQSelect.propTypes = {
  options: PropTypes__default["default"].array,
  placeholder: PropTypes__default["default"].string,
  variant: PropTypes__default["default"].string,
  color: PropTypes__default["default"].string,
  errorTextStyle: PropTypes__default["default"].object,
  errorText: PropTypes__default["default"].string,
  avatarProps: PropTypes__default["default"].object,
  customIcon: PropTypes__default["default"].element,
  avatar: PropTypes__default["default"].bool
};
FormCQSelect.propTypes = {
  options: PropTypes__default["default"].array,
  placeholder: PropTypes__default["default"].string,
  variant: PropTypes__default["default"].string,
  color: PropTypes__default["default"].string,
  errorTextStyle: PropTypes__default["default"].object,
  control: PropTypes__default["default"].object,
  avatarProps: PropTypes__default["default"].object,
  customIcon: PropTypes__default["default"].element,
  avatar: PropTypes__default["default"].bool
};

function PrimaryButton(props) {
  return /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    style: {
      padding: '20'
    },
    isLoading: props.isLoading,
    colorScheme: props.colorScheme,
    variant: props.variant,
    leftIcon: props.leftIcon
  }, props));
}

// Icon button
function SecondaryButton(props) {
  return /*#__PURE__*/React__default["default"].createElement(react.IconButton, _extends$2({
    borderRadius: props.borderRadius,
    colorScheme: props.colorScheme,
    ariaLabel: props.ariaLabel,
    fontSize: props.fontSize,
    icon: props.icon,
    variant: props.variant,
    isLoading: props.isLoading
  }, props));
}
PrimaryButton.propTypes = {
  colorScheme: PropTypes__default["default"].string,
  variant: PropTypes__default["default"].string,
  style: PropTypes__default["default"].object,
  leftIcon: PropTypes__default["default"].element,
  isLoading: PropTypes__default["default"].string
};
SecondaryButton.propTypes = {
  colorScheme: PropTypes__default["default"].string,
  variant: PropTypes__default["default"].string,
  style: PropTypes__default["default"].object,
  icon: PropTypes__default["default"].element,
  ariaLabel: PropTypes__default["default"].string,
  fontSize: PropTypes__default["default"].number,
  isLoading: PropTypes__default["default"].string
};
PrimaryButton.defaultProps = {
  colorScheme: MID_NIGHT_BLUE,
  variant: 'solid'
};
SecondaryButton.defaultProps = {
  colorScheme: MID_NIGHT_BLUE,
  variant: 'solid'
};

const TextInput = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
  const {
    leftIcon,
    leftIconProps,
    wrapperProps,
    rightIcon,
    rightIconProps,
    isInvalid,
    errorText,
    errorTextStyle,
    ...rest
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(react.FormControl, null, /*#__PURE__*/React__default["default"].createElement(react.InputGroup, _extends$2({
    bgColor: WHITE_COLOR
  }, wrapperProps), leftIcon && /*#__PURE__*/React__default["default"].createElement(react.InputLeftElement, _extends$2({}, leftIconProps, {
    children: leftIcon
  })), /*#__PURE__*/React__default["default"].createElement(react.Input, _extends$2({
    ref: ref,
    errorBorderColor: DANGER
  }, rest)), rightIcon && /*#__PURE__*/React__default["default"].createElement(react.InputRightElement, _extends$2({}, rightIconProps, {
    children: rightIcon
  }))), isInvalid && /*#__PURE__*/React__default["default"].createElement(react.Text, {
    color: DANGER,
    style: {
      ...errorTextStyle
    }
  }, errorText));
});
const FormTextInput = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
  const controller = reactHookForm.useController({
    control: props.control,
    defaultValue: '',
    name: props.name
  });
  const handleChange = e => {
    if (props.onChange) {
      props.onChange(e);
    }
    controller.field.onChange(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(TextInput, _extends$2({
    ref: ref,
    value: controller.field.value,
    isInvalid: controller.fieldState?.error?.message,
    errorText: controller.fieldState?.error?.message
  }, props, {
    onChange: handleChange
  }));
});
FormTextInput.propTypes = {
  id: PropTypes__default["default"].string,
  placeholder: PropTypes__default["default"].string,
  size: PropTypes__default["default"].string,
  leftIcon: PropTypes__default["default"].element,
  leftIconProps: PropTypes__default["default"].object,
  rightIcon: PropTypes__default["default"].element,
  rightIconProps: PropTypes__default["default"].object,
  control: PropTypes__default["default"].object,
  name: PropTypes__default["default"].string,
  wrapperProps: PropTypes__default["default"].object,
  errorTextStyle: PropTypes__default["default"].object,
  onChange: PropTypes__default["default"].func
};
TextInput.propTypes = {
  id: PropTypes__default["default"].string,
  placeholder: PropTypes__default["default"].string,
  size: PropTypes__default["default"].string,
  leftIcon: PropTypes__default["default"].element,
  leftIconProps: PropTypes__default["default"].object,
  rightIcon: PropTypes__default["default"].element,
  rightIconProps: PropTypes__default["default"].object,
  errorText: PropTypes__default["default"].string,
  errorTextStyle: PropTypes__default["default"].object,
  wrapperProps: PropTypes__default["default"].object,
  onChange: PropTypes__default["default"].func
};

var MailIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='21px' height='14px' viewBox='0 0 21 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e3045EF17-9EA9-48C4-BDAE-40CBF2C7872F%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-Login' transform='translate(-1051.000000%2c -430.000000)' fill='black' fill-rule='nonzero'%3e %3cg id='noun-mail-953541' transform='translate(1051.000000%2c 430.000000)'%3e %3cpath d='M20.7212922%2c1.15426852 C20.5712203%2c0.876361634 20.3570275%2c0.641256045 20.0999434%2c0.44892885 C19.7143076%2c0.171021968 19.2642333%2c0 18.749912%2c0 L2.24999617%2c0 C1.73567482%2c0 1.28575364%2c0.171010518 0.899964796%2c0.44892885 C0.642869169%2c0.641259862 0.42853863%2c0.876369267 0.278615925%2c1.15426852 C0.0857942051%2c1.47481639 0%2c1.83831059 0%2c2.24430074 L0%2c11.7556993 C0%2c12.1831397 0.128547814%2c12.5679467 0.321365707%2c12.9098151 C0.492812537%2c13.187722 0.707001495%2c13.4013773 0.964257835%2c13.5938572 C1.32852256%2c13.8502985 1.77857766%2c14 2.25004209%2c14 L18.7499579%2c14 C19.2213841%2c14 19.6713052%2c13.85031 20.0357422%2c13.5938572 C20.2928378%2c13.4228467 20.5071683%2c13.1877144 20.6786343%2c12.9098151 C20.8929801%2c12.5677979 21%2c12.1831397 21%2c11.7556993 L21%2c2.24430074 C21%2c1.85964635 20.8928271%2c1.49628955 20.7213841%2c1.15426852 L20.7212922%2c1.15426852 Z M2.24995791%2c0.940617009 L18.7498737%2c0.940617009 C18.9642196%2c0.940617009 19.1570528%2c0.983406852 19.3284805%2c1.06883768 L11.0570941%2c7.48101646 C10.9070222%2c7.60923714 10.7142043%2c7.67334747 10.5213825%2c7.67334747 C10.3285608%2c7.67334747 10.1357468%2c7.60923714 9.98567099%2c7.48101646 L1.71428462%2c1.06883768 C1.84298167%2c0.983257998 2.03579956%2c0.940617009 2.24999617%2c0.940617009 L2.24995791%2c0.940617009 Z M0.921431523%2c11.7771991 L0.921431523%2c2.26580062 C0.921431523%2c2.0947901 0.964330539%2c1.90246291 1.02860445%2c1.75278815 L7.26428692%2c6.58329617 L1.02860445%2c12.2901353 C0.964330539%2c12.1192736 0.921431523%2c11.9482669 0.921431523%2c11.7772373 L0.921431523%2c11.7771991 Z M18.749912%2c13.0810088 L2.24999617%2c13.0810088 C2.03565033%2c13.0810088 1.84281713%2c13.038219 1.67138943%2c12.9527882 L7.99278575%2c7.13907939 L9.36420733%2c8.20777586 C9.68557303%2c8.44289671 10.0713466%2c8.59243025 10.4785256%2c8.59243025 C10.8857047%2c8.59243025 11.2713405%2c8.46420957 11.5928439%2c8.20777586 L12.9642655%2c7.13907939 L19.2856618%2c12.9527882 C19.1569648%2c13.0383678 18.9641469%2c13.0810088 18.7499503%2c13.0810088 L18.749912%2c13.0810088 Z M13.7356519%2c6.5619604 L19.9713343%2c1.73145239 C20.0356082%2c1.88114241 20.0785073%2c2.05200026 20.0785073%2c2.24446486 L20.0785073%2c11.7558634 C20.0785073%2c11.9268739 20.0356082%2c12.1192011 19.9713343%2c12.2688759 L13.7356519%2c6.5619604 Z' id='Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var EyeHiddenIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='24px' height='20px' viewBox='0 0 24 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e1755FD4C-F02D-4338-9E85-1E0A1EEF4360%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-Login' transform='translate(-1387.000000%2c -496.000000)' fill='black' fill-rule='nonzero'%3e %3cg id='noun-hidden-2978637' transform='translate(1387.000000%2c 496.000000)'%3e %3cpath d='M23.8839457%2c9.65734069 C23.7420403%2c9.47282101 21.4719471%2c6.56402888 18.0846765%2c4.58840637 L21.6585392%2c0.948440111 C21.8718508%2c0.731183062 21.8718508%2c0.380167098 21.6585392%2c0.162933858 C21.4452277%2c-0.0542993815 21.1005863%2c-0.0543231905 20.8872982%2c0.162933858 L17.0740122%2c4.04675181 C15.5420963%2c3.29567336 13.8244765%2c2.77782779 11.9998855%2c2.77782779 C5.48295441%2c2.77782779 0.332152393%2c9.37625174 0.116152526%2c9.65719784 C-0.0387175086%2c9.8582743 -0.0387175086%2c10.1409966 0.116152526%2c10.3422778 C0.258057893%2c10.5267975 2.52815104%2c13.4355896 5.91542168%2c15.4112121 L2.34155895%2c19.0511784 C2.12824739%2c19.2684354 2.12824739%2c19.6194514 2.34155895%2c19.8366846 C2.44803005%2c19.9455012 2.58774269%2c20 2.72745533%2c20 C2.86716797%2c20 3.00669828%2c19.9455012 3.11316938%2c19.8372417 L6.92645534%2c15.9534238 C8.45799725%2c16.7045022 10.175617%2c17.2223478 12.0001145%2c17.2223478 C18.5170456%2c17.2223478 23.6678476%2c10.6239239 23.8838475%2c10.3429778 C24.0387175%2c10.1413442 24.0387175%2c9.85898857 23.8838475%2c9.65737403 L23.8839457%2c9.65734069 Z M1.25725832%2c10.0001521 C2.39611995%2c8.6646105 6.82883929%2c3.88933628 11.9997452%2c3.88933628 C13.4964092%2c3.88933628 14.9276655%2c4.295951 16.2383919%2c4.89712328 L14.6707098%2c6.49380188 C13.9317752%2c5.90805307 13.0065757%2c5.5559657 11.9997452%2c5.5559657 C9.59377785%2c5.5559657 7.63617386%2c7.54977828 7.63617386%2c10.0002473 C7.63617386%2c11.0257006 7.98207287%2c11.9680129 8.55679147%2c12.7208056 L6.72850689%2c14.5829068 C4.01864362%2c13.0645122 1.97744488%2c10.845276 1.2569778%2c10.0002473 L1.25725832%2c10.0001521 Z M15.2724704%2c10.0001521 C15.2724704%2c11.8384443 13.8046532%2c13.3334109 11.9997452%2c13.3334109 C11.2938651%2c13.3334109 10.6415175%2c13.1023875 10.1064269%2c12.7139962 L14.6643046%2c8.07181423 C15.0456332%2c8.61680205 15.2724704%2c9.28121577 15.2724704%2c10.0001521 Z M8.72701994%2c10.0001521 C8.72701994%2c8.16185983 10.1948372%2c6.66689325 11.9997452%2c6.66689325 C12.7056253%2c6.66689325 13.3579729%2c6.89791666 13.8930635%2c7.28630798 L9.3351858%2c11.9284899 C8.9538572%2c11.3835021 8.72701994%2c10.7190884 8.72701994%2c10.0001521 L8.72701994%2c10.0001521 Z M11.9997452%2c16.1109679 C10.5030812%2c16.1109679 9.07182492%2c15.7043532 7.76109846%2c15.1031809 L9.32878061%2c13.5065023 C10.0677152%2c14.0922511 10.9929146%2c14.4443385 11.9997452%2c14.4443385 C14.4057125%2c14.4443385 16.3633165%2c12.4505259 16.3633165%2c10.0000568 C16.3633165%2c8.97460357 16.0174175%2c8.0322913 15.4426989%2c7.2794986 L17.2709835%2c5.41739737 C19.9814078%2c6.935792 22.022513%2c9.15502811 22.7429801%2c10.0000568 C21.6035575%2c11.3355984 17.1709316%2c16.1109679 11.9995582%2c16.1109679 L11.9997452%2c16.1109679 Z' id='Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var EyeIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='15px' viewBox='0 0 20 15' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e82EF73FC-25A7-4C28-B1FF-3FB73A5FE927%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Stylesheet' transform='translate(-774.000000%2c -402.000000)' fill='%23010101' fill-rule='nonzero'%3e %3cg id='Group-Copy' transform='translate(774.000000%2c 402.000000)'%3e %3cpath d='M9.84%2c14.28 C5.86%2c14.28 2.4%2c11.05 0.75%2c9.17 L0.75%2c9.17 C0.3%2c8.57 0%2c7.89 0%2c7.14 C0%2c6.39 0.3%2c5.64 0.75%2c5.11 C2.4%2c3.16 5.86%2c0 9.84%2c0 C13.82%2c0 17.28%2c3.23 18.93%2c5.11 L18.93%2c5.11 C19.38%2c5.71 19.68%2c6.39 19.68%2c7.14 C19.68%2c7.89 19.38%2c8.64 18.93%2c9.17 C17.28%2c11.05 13.9%2c14.28 9.84%2c14.28 Z M9.84%2c1.74 C6.53%2c1.74 3.6%2c4.6 2.1%2c6.25 C1.87%2c6.48 1.8%2c6.78 1.8%2c7.08 C1.8%2c7.38 1.88%2c7.68 2.1%2c7.91 C3.6%2c9.56 6.61%2c12.42 9.84%2c12.42 C13.15%2c12.42 16.08%2c9.56 17.58%2c7.91 C17.81%2c7.68 17.88%2c7.38 17.88%2c7.08 C17.88%2c6.78 17.8%2c6.48 17.58%2c6.25 C16.16%2c4.59 13.15%2c1.74 9.84%2c1.74 L9.84%2c1.74 Z' id='Shape'%3e%3c/path%3e %3cpath d='M9.84%2c10.68 C8.86%2c10.68 7.96%2c10.3 7.29%2c9.63 C6.61%2c8.95 6.24%2c8.05 6.24%2c7.08 C6.24%2c6.1 6.62%2c5.2 7.29%2c4.53 C7.97%2c3.85 8.87%2c3.48 9.84%2c3.48 C10.82%2c3.48 11.72%2c3.86 12.39%2c4.53 C13.07%2c5.21 13.44%2c6.11 13.44%2c7.08 C13.44%2c8.06 13.06%2c8.96 12.39%2c9.63 C11.72%2c10.3 10.82%2c10.68 9.84%2c10.68 Z M9.84%2c5.34 C9.39%2c5.34 8.94%2c5.57 8.56%2c5.87 C8.26%2c6.17 8.03%2c6.7 8.03%2c7.15 C8.03%2c7.6 8.26%2c8.05 8.56%2c8.43 C8.86%2c8.73 9.39%2c8.96 9.84%2c8.96 C10.29%2c8.96 10.74%2c8.73 11.12%2c8.43 C11.42%2c8.13 11.65%2c7.6 11.65%2c7.15 C11.65%2c6.7 11.42%2c6.25 11.12%2c5.87 C10.82%2c5.49 10.37%2c5.34 9.84%2c5.34 Z' id='Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var LeftIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='50px' height='50px' viewBox='0 0 50 50' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eC8CD765A-D73E-4D7B-B993-0D78FAADDF51%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-Assign-Auditor' transform='translate(-1517.000000%2c -933.000000)'%3e %3cg id='Group-4' transform='translate(1517.000000%2c 933.000000)'%3e %3crect id='Rectangle' fill='%23EBEBEE' transform='translate(25.000000%2c 25.000000) scale(1%2c -1) translate(-25.000000%2c -25.000000) ' x='0' y='0' width='50' height='50' rx='10'%3e%3c/rect%3e %3cpath d='M24.6375%2c28.7375 C24.9375%2c28.7375 25.2375%2c28.6375 25.4375%2c28.4375 L30.9375%2c22.9375 C31.1375%2c22.7375 31.2375%2c22.4375 31.2375%2c22.1375 C31.2375%2c21.8375 31.1375%2c21.5375 30.9375%2c21.3375 C30.7375%2c21.1375 30.4375%2c21.0375 30.1375%2c21.0375 C29.8375%2c21.0375 29.5375%2c21.1375 29.3375%2c21.3375 L24.6375%2c26.0375 L19.9375%2c21.3375 L19.9375%2c21.3375 C19.6375%2c21.0375 19.2375%2c20.9375 18.8375%2c21.0375 C18.4375%2c21.1375 18.1375%2c21.4375 18.0375%2c21.8375 C17.9375%2c22.2375 18.0375%2c22.6375 18.3375%2c22.9375 L23.8375%2c28.4375 C24.0375%2c28.6375 24.3375%2c28.7375 24.6375%2c28.7375 L24.6375%2c28.7375 Z' id='Path' fill='black' fill-rule='nonzero' opacity='0.299383254' transform='translate(24.618750%2c 24.868750) scale(-1%2c 1) rotate(-90.000000) translate(-24.618750%2c -24.868750) '%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var RightIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='50px' height='50px' viewBox='0 0 50 50' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e892DEF26-2840-4B6B-868E-71C26B0F7201%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-Assign-Auditor' transform='translate(-1577.000000%2c -933.000000)'%3e %3cg id='Group-3' transform='translate(1577.000000%2c 933.000000)'%3e %3crect id='Rectangle' fill='%23F0F0F0' transform='translate(25.000000%2c 25.000000) scale(1%2c -1) translate(-25.000000%2c -25.000000) ' x='0' y='0' width='50' height='50' rx='10'%3e%3c/rect%3e %3cpath d='M24.6375%2c28.7375 C24.9375%2c28.7375 25.2375%2c28.6375 25.4375%2c28.4375 L30.9375%2c22.9375 C31.1375%2c22.7375 31.2375%2c22.4375 31.2375%2c22.1375 C31.2375%2c21.8375 31.1375%2c21.5375 30.9375%2c21.3375 C30.7375%2c21.1375 30.4375%2c21.0375 30.1375%2c21.0375 C29.8375%2c21.0375 29.5375%2c21.1375 29.3375%2c21.3375 L24.6375%2c26.0375 L19.9375%2c21.3375 L19.9375%2c21.3375 C19.6375%2c21.0375 19.2375%2c20.9375 18.8375%2c21.0375 C18.4375%2c21.1375 18.1375%2c21.4375 18.0375%2c21.8375 C17.9375%2c22.2375 18.0375%2c22.6375 18.3375%2c22.9375 L23.8375%2c28.4375 C24.0375%2c28.6375 24.3375%2c28.7375 24.6375%2c28.7375 L24.6375%2c28.7375 Z' id='Path' fill='black' fill-rule='nonzero' opacity='0.299383254' transform='translate(24.618750%2c 24.868750) rotate(-90.000000) translate(-24.618750%2c -24.868750) '%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var DotMenu$1 = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='5px' height='21px' viewBox='0 0 5 21' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e032B129F-4AA8-46E3-BE02-23135BEF2D2F%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Stylesheet' transform='translate(-957.000000%2c -771.000000)' fill='%236D747E'%3e %3cg id='Group-2' transform='translate(957.000000%2c 771.000000)'%3e %3ccircle id='Oval' cx='2.5' cy='2.5' r='2.5'%3e%3c/circle%3e %3ccircle id='Oval-Copy' cx='2.5' cy='10.5' r='2.5'%3e%3c/circle%3e %3ccircle id='Oval-Copy-2' cx='2.5' cy='18.5' r='2.5'%3e%3c/circle%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var LockIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='20px' viewBox='0 0 16 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eC7552948-246E-4190-A542-EFCB35B6B46B%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-Login' transform='translate(-1054.000000%2c -496.000000)' fill='black' fill-rule='nonzero'%3e %3cg id='noun-lock-locked-4020631(1)' transform='translate(1054.000000%2c 496.000000)'%3e %3cpath d='M13.5300277%2c7.50271522 L12.9180088%2c7.50271522 L12.9180088%2c5.10539793 C12.9180088%2c2.24201489 10.8853099%2c0 7.97814218%2c0 C5.07105254%2c0 3.08199121%2c2.28633038 3.08199121%2c5.10539793 L3.08199121%2c7.48059711 L3.08199121%2c7.48059711 L2.46997234%2c7.48059711 C1.11482672%2c7.48059711 0.0219358805%2c8.59046622 0%2c9.98894095 L0%2c17.4916562 C0%2c18.8678542 1.09289084%2c19.9777233 2.46997234%2c20 L13.5300277%2c20 C14.8851733%2c20 15.9780641%2c18.8901309 16%2c17.4916562 L16%2c9.98854457 C16%2c8.6123465 14.8851733%2c7.50247739 13.5300277%2c7.50247739 L13.5300277%2c7.50271522 Z M4.30602895%2c7.50273876 L4.30602895%2c5.10539793 C4.30602895%2c2.97436995 5.7486839%2c1.24301377 7.97806412%2c1.24301377 C10.1856646%2c1.24301377 11.693854%2c2.92997519 11.693854%2c5.10539793 L11.693854%2c7.48059711 L11.693854%2c7.48059711 L4.30591186%2c7.48044228 L4.30591186%2c7.50273876 L4.30602895%2c7.50273876 Z M14.7540654%2c17.4915372 C14.7540654%2c18.1796165 14.20762%2c18.734551 13.5300667%2c18.734551 L2.47001137%2c18.734551 C1.79245808%2c18.734551 1.24601266%2c18.1796165 1.24601266%2c17.4915372 L1.24601266%2c9.98882203 C1.24601266%2c9.30074282 1.79245808%2c8.74580826 2.47001137%2c8.74580826 L13.5300667%2c8.74580826 C14.20762%2c8.74580826 14.7540654%2c9.30074282 14.7540654%2c9.98882203 L14.7540654%2c17.4915372 Z M9.22403774%2c12.4971262 C9.22403774%2c12.9633505 8.98359395%2c13.3628241 8.61201887%2c13.5848376 L8.59021609%2c13.5848376 L8.61201887%2c13.5848376 L8.61201887%2c15.6269968 C8.61201887%2c15.9821906 8.32782041%2c16.2485235 8%2c16.2485235 C7.6502398%2c16.2485235 7.38798113%2c15.9599099 7.38798113%2c15.6269968 L7.38798113%2c13.5848376 L7.40978391%2c13.5848376 L7.38798113%2c13.5848376 C7.01641776%2c13.3628004 6.77596226%2c12.9633109 6.77596226%2c12.4971262 C6.77596226%2c11.809047 7.32240768%2c11.2541125 7.99996097%2c11.2541125 C8.67751426%2c11.231816 9.22395968%2c11.7867704 9.22395968%2c12.4971262 L9.22403774%2c12.4971262 Z' id='Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var MarkIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='104px' height='104px' viewBox='0 0 104 104' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e4BBB3E4F-EF2F-4A1D-A5EF-8688DD2063F8%3c/title%3e %3cdefs%3e %3ccircle id='path-1' cx='42' cy='42' r='42'%3e%3c/circle%3e %3cfilter x='-17.9%25' y='-17.9%25' width='135.7%25' height='135.7%25' filterUnits='objectBoundingBox' id='filter-2'%3e %3cfeOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter1'%3e%3c/feOffset%3e %3cfeGaussianBlur stdDeviation='5' in='shadowOffsetOuter1' result='shadowBlurOuter1'%3e%3c/feGaussianBlur%3e %3cfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0523374331 0' type='matrix' in='shadowBlurOuter1'%3e%3c/feColorMatrix%3e %3c/filter%3e %3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-Reset-Password-Success' transform='translate(-1180.000000%2c -344.000000)'%3e %3cg id='mark' transform='translate(1190.000000%2c 354.000000)'%3e %3cg id='Oval'%3e %3cuse fill='black' fill-opacity='1' filter='url(%23filter-2)' xlink:href='%23path-1'%3e%3c/use%3e %3cuse fill='white' fill-rule='evenodd' xlink:href='%23path-1'%3e%3c/use%3e %3c/g%3e %3cpath d='M57.2804978%2c26.3722647 C55.0177717%2c28.3432132 52.937594%2c30.4233909 50.8571556%2c32.5766271 C48.8134093%2c34.7301239 46.8060294%2c36.9197915 44.8717079%2c39.1825175 C42.0249705%2c42.576574 39.2877231%2c46.1168777 36.7329588%2c49.766541 L27.4628142%2c39.8029603 C27.0249328%2c39.3284259 26.2950523%2c39.1825501 25.711041%2c39.54736 C25.0175398%2c39.948836 24.7986251%2c40.8248725 25.2001011%2c41.5180478 C25.2001011%2c41.5180478 34.0322862%2c56.7371436 34.3972525%2c57.394083 C34.7623231%2c58.0144932 35.5652751%2c59 37.2075584%2c59 C38.8134754%2c59 39.6891991%2c58.0511527 40.2004126%2c57.0656785 C40.7477578%2c56.0437728 45.638476%2c46.9926079 48.8136179%2c42.211549 C50.3828428%2c39.8027061 52.0981845%2c37.4669216 53.8135914%2c35.167699 C55.5653646%2c32.8683459 57.3901962%2c30.6056199 59.2516548%2c28.4888152 L59.2880595%2c28.4524105 C59.7623398%2c27.8320003 59.7623398%2c27.0290418 59.287805%2c26.481462 C58.7769379%2c25.8977303 57.864509%2c25.824926 57.2804978%2c26.3722647 Z' id='Path' fill='%23023B93' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var SuccessToastIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='71px' height='71px' viewBox='0 0 71 71' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eA1F2C604-6948-4AB6-B201-8A86A964C9AB%3c/title%3e %3cdefs%3e %3ccircle id='path-1' cx='25.5' cy='25.5' r='25.5'%3e%3c/circle%3e %3cfilter x='-29.4%25' y='-29.4%25' width='158.8%25' height='158.8%25' filterUnits='objectBoundingBox' id='filter-2'%3e %3cfeOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter1'%3e%3c/feOffset%3e %3cfeGaussianBlur stdDeviation='5' in='shadowOffsetOuter1' result='shadowBlurOuter1'%3e%3c/feGaussianBlur%3e %3cfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0523374331 0' type='matrix' in='shadowBlurOuter1'%3e%3c/feColorMatrix%3e %3c/filter%3e %3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Manager-%7c-A-new-team-save' transform='translate(-1780.000000%2c -83.000000)'%3e %3cg id='success' transform='translate(1499.000000%2c 74.000000)'%3e %3cg id='mark' transform='translate(291.000000%2c 19.000000)'%3e %3cg id='Oval'%3e %3cuse fill='black' fill-opacity='1' filter='url(%23filter-2)' xlink:href='%23path-1'%3e%3c/use%3e %3cuse fill='white' fill-rule='evenodd' xlink:href='%23path-1'%3e%3c/use%3e %3c/g%3e %3cpath d='M35.5674743%2c16.2256309 C34.1958773%2c17.4201442 32.9349357%2c18.6808569 31.673836%2c19.9858475 C30.434978%2c21.290996 29.2181642%2c22.6180662 28.0456362%2c23.9894142 C26.320029%2c26.0464165 24.6607913%2c28.1920534 23.1121695%2c30.4039687 L17.4928844%2c24.3654398 C17.2274538%2c24.0778435 16.785022%2c23.989434 16.4310118%2c24.2105307 C16.0106321%2c24.4538493 15.8779326%2c24.9847801 16.1212953%2c25.404886 C16.1212953%2c25.404886 21.4751023%2c34.628573 21.696334%2c35.0267178 C21.9176289%2c35.4027236 22.4043545%2c36 23.3998576%2c36 C24.3733165%2c36 24.9041541%2c35.4249415 25.2140365%2c34.8276849 C25.5458208%2c34.2083486 28.5104282%2c28.7227985 30.4351045%2c25.8251894 C31.3863217%2c24.3652858 32.4261107%2c22.94966 33.4659392%2c21.5561928 C34.5278118%2c20.1626467 35.6339703%2c18.7912986 36.7623309%2c17.5083877 L36.7843984%2c17.4863243 C37.0718929%2c17.1103184 37.0718929%2c16.6236773 36.7842441%2c16.291811 C36.4745717%2c15.9380345 35.9214846%2c15.8939107 35.5674743%2c16.2256309 Z' id='Path' fill='%23023B93' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var SortIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='12px' height='17px' viewBox='0 0 12 17' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eDE50C546-FBBB-4A55-AFDB-9A8A9F8880E3%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Stylesheet' transform='translate(-300.000000%2c -1563.000000)' fill='%23AEAEAE'%3e %3cg id='Group-75' transform='translate(231.000000%2c 1562.000000)'%3e %3cg id='Group' transform='translate(69.000000%2c 1.000000)'%3e %3cpath d='M6.76822128%2c9.92186554 L10.6331797%2c14.5598156 C10.9867437%2c14.9840925 10.9294197%2c15.6146572 10.5051428%2c15.9682213 C10.3254278%2c16.1179838 10.0988949%2c16.2 9.86495839%2c16.2 L2.13504161%2c16.2 C1.58275686%2c16.2 1.13504161%2c15.7522847 1.13504161%2c15.2 C1.13504161%2c14.9660635 1.21705783%2c14.7395306 1.36682033%2c14.5598156 L5.23177872%2c9.92186554 C5.5853428%2c9.49758864 6.2159075%2c9.44026457 6.6401844%2c9.79382866 C6.68664746%2c9.83254788 6.72950206%2c9.87540247 6.76822128%2c9.92186554 Z' id='Triangle-Copy-15' transform='translate(6.000000%2c 12.600000) scale(1%2c -1) translate(-6.000000%2c -12.600000) '%3e%3c/path%3e %3cpath d='M6.76822128%2c0.921865536 L10.6331797%2c5.5598156 C10.9867437%2c5.9840925 10.9294197%2c6.6146572 10.5051428%2c6.96822128 C10.3254278%2c7.11798378 10.0988949%2c7.2 9.86495839%2c7.2 L2.13504161%2c7.2 C1.58275686%2c7.2 1.13504161%2c6.75228475 1.13504161%2c6.2 C1.13504161%2c5.96606349 1.21705783%2c5.7395306 1.36682033%2c5.5598156 L5.23177872%2c0.921865536 C5.5853428%2c0.497588638 6.2159075%2c0.440264575 6.6401844%2c0.793828656 C6.68664746%2c0.832547876 6.72950206%2c0.875402471 6.76822128%2c0.921865536 Z' id='Triangle-Copy-16'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var UpIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='10px' viewBox='0 0 14 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e4C231EF2-EE87-4E2F-BDD5-0948F16927C9%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Stylesheet' transform='translate(-120.000000%2c -565.000000)' fill='%23AEAEAE'%3e %3cpolygon id='Triangle' points='127 565 134 575 120 575'%3e%3c/polygon%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

var DownIconData = "var img = \"data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='10px' viewBox='0 0 14 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e5C9170C3-5273-4BE4-B5F4-6EC0363E52F5%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Stylesheet' transform='translate(-138.000000%2c -565.000000)' fill='%23AEAEAE'%3e %3cpolygon id='Triangle' transform='translate(145.000000%2c 570.000000) rotate(-180.000000) translate(-145.000000%2c -570.000000) ' points='145 565 152 575 138 575'%3e%3c/polygon%3e %3c/g%3e %3c/g%3e%3c/svg%3e\";\n  export default img;";

// sort
const SortIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "sort-icon",
  src: SortIconData,
  style: {
    width: 14,
    height: 14
  }
}, props));
const UpIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "sort-icon",
  src: UpIconData,
  style: {
    width: 14,
    height: 14
  }
}, props));
const DownIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "sort-icon",
  src: DownIconData,
  style: {
    width: 14,
    height: 14
  }
}, props));
const MailIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "mail-icon",
  src: MailIconData,
  style: {
    width: 18,
    height: 18
  }
}, props));
const EyeHiddenIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "eye-hidden-icon",
  src: EyeHiddenIconData,
  style: {
    width: 18,
    height: 18
  }
}, props));
const EyeIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "eye-icon",
  src: EyeIconData,
  style: {
    width: 18,
    height: 18
  }
}, props));
const RightIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "right-icon",
  src: RightIconData,
  style: {
    width: 40,
    height: 40
  }
}, props));
const LeftIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "left-icon",
  src: LeftIconData,
  style: {
    width: 40,
    height: 40
  }
}, props));
const DotMenuIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "dotmenu-icon",
  src: DotMenu$1,
  style: {
    width: 18,
    height: 18
  }
}, props));
const LockIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "lock-icon",
  src: LockIconData,
  style: {
    width: 18,
    height: 18
  }
}, props));
const MarkIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "lock-icon",
  src: MarkIconData,
  style: {
    width: 84,
    height: 84
  }
}, props));
const SuccessToastIcon = props => /*#__PURE__*/React__default["default"].createElement("img", _extends$2({
  alt: "success-icon-icon",
  src: SuccessToastIconData,
  style: {
    width: 60,
    height: 60
  }
}, props));

const CQPagination = ({
  currentPage,
  setCurrentPage,
  total,
  size,
  pageCount,
  handlePageChangeByNumber,
  textProps,
  leftIcon,
  rightIcon,
  sizeDropDown,
  containerProps
}) => {
  const from = (currentPage - 1) * size;
  const THRESHOLD_PAGE_DIFF = 5;
  const to = currentPage * size;
  const buttonStyle = {
    padding: '0px 10px',
    border: '0px solid',
    borderRadius: '3px',
    backgroundColor: 'white',
    minWidth: '30px',
    height: "30px",
    fontSize: '14px',
    fontWeight: 'normal',
    transition: 'background-color 0.3s ease',
    marginTop: "5px"
  };
  const hoverStyle = {
    backgroundColor: 'lightgray'
  };
  const onPreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  const onNextClick = () => {
    if (currentPage < pageCount) {
      setCurrentPage(prev => prev + 1);
    }
  };
  const handleMouseHover = (e, isCurrentPage = false) => {
    if (!isCurrentPage) {
      e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor;
    }
  };
  const handleMouseExit = e => {
    e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor;
  };
  const before = React__default["default"].useMemo(() => {
    if (currentPage < 3 || pageCount <= 3) {
      return null;
    }
    return [1];
  }, [currentPage, pageCount]);
  const current = React__default["default"].useMemo(() => {
    if (currentPage < 3) {
      return Array.from({
        length: Math.min(pageCount, 3)
      }, (_, i) => i + 1);
    }
    if (currentPage + 1 >= pageCount) {
      return [pageCount - 2, pageCount - 1, pageCount];
    }
    return Array.from({
      length: 3
    }, (_, i) => currentPage - 1 + i);
  }, [currentPage, pageCount]);
  const after = React__default["default"].useMemo(() => {
    if (currentPage + 1 >= pageCount || pageCount <= 3) {
      return null;
    }
    return [pageCount];
  }, [currentPage, pageCount]);
  return /*#__PURE__*/React__default["default"].createElement(react.Flex, _extends$2({}, containerProps, {
    marginTop: "10px"
  }), /*#__PURE__*/React__default["default"].createElement(react.HStack, {
    paddingBottom: 2,
    paddingTop: 2
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, _extends$2({
    fontSize: "sm"
  }, textProps), from || 1, "-", to > total ? total : to, " of ", total), sizeDropDown), /*#__PURE__*/React__default["default"].createElement(react.Spacer, null), pageCount > 1 ? /*#__PURE__*/React__default["default"].createElement(react.ButtonGroup, {
    spacing: 1,
    variant: "solid"
  }, leftIcon || /*#__PURE__*/React__default["default"].createElement(LeftIcon, {
    onClick: onPreviousClick,
    style: {
      cursor: 'pointer'
    }
  }), before?.map(page => {
    return /*#__PURE__*/React__default["default"].createElement("button", {
      key: page,
      onMouseOver: handleMouseHover,
      onMouseOut: handleMouseExit,
      onClick: () => handlePageChangeByNumber(page),
      style: buttonStyle
    }, page);
  }), before && before[before.length - 1] + 1 != current[0] && /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      marginTop: "5px"
    }
  }, " \xA0....\xA0 "), (() => {
    if (before == null) {
      return;
    }
    const prev = before[before.length - 1];
    const cur = current[0];
    if (prev + THRESHOLD_PAGE_DIFF <= cur) {
      const mid = Math.floor((prev + cur) / 2);
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("button", {
        key: mid,
        onMouseOver: handleMouseHover,
        onMouseOut: handleMouseExit,
        onClick: () => handlePageChangeByNumber(mid),
        style: buttonStyle
      }, mid), /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          marginTop: "3px"
        }
      }, " \xA0....\xA0 "));
    }
  })(), current.map(page => {
    const isCurrentPage = page === currentPage;
    return /*#__PURE__*/React__default["default"].createElement("button", {
      key: page,
      onMouseOver: e => handleMouseHover(e, isCurrentPage),
      onMouseOut: e => handleMouseExit(e),
      disabled: isCurrentPage,
      onClick: () => handlePageChangeByNumber(page),
      style: {
        ...buttonStyle,
        fontWeight: isCurrentPage ? 'bold' : 'normal',
        cursor: isCurrentPage ? 'default' : 'pointer',
        border: isCurrentPage ? '1px solid' : '0px'
      }
    }, page);
  }), after && after[0] - 1 != current[current.length - 1] && /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      marginTop: "5px"
    }
  }, "\xA0....\xA0"), (() => {
    if (after == null) {
      return;
    }
    const prev = current[current.length - 1];
    const cur = after[0];
    if (prev + THRESHOLD_PAGE_DIFF <= cur) {
      const mid = Math.floor((prev + cur) / 2);
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("button", {
        key: mid,
        onMouseOver: handleMouseHover,
        onMouseOut: handleMouseExit,
        onClick: () => handlePageChangeByNumber(mid),
        style: buttonStyle
      }, mid), /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          marginTop: "3px"
        }
      }, " \xA0....\xA0 "));
    }
  })(), after?.map(page => {
    return /*#__PURE__*/React__default["default"].createElement("button", {
      key: page,
      onMouseOver: handleMouseHover,
      onMouseOut: handleMouseExit,
      onClick: () => handlePageChangeByNumber(page),
      style: buttonStyle
    }, page);
  }), rightIcon || /*#__PURE__*/React__default["default"].createElement(RightIcon, {
    onClick: onNextClick,
    style: {
      cursor: 'pointer'
    }
  })) : null);
};
CQPagination.propTypes = {
  total: PropTypes__default["default"].number,
  size: PropTypes__default["default"].number,
  currentPage: PropTypes__default["default"].number,
  setCurrentPage: PropTypes__default["default"].func,
  textProps: PropTypes__default["default"].object,
  leftIcon: PropTypes__default["default"].element,
  rightIcon: PropTypes__default["default"].element,
  containerProps: PropTypes__default["default"].object
};
CQPagination.defaultProps = {
  total: 1,
  currentPage: 1,
  size: 10
};

const PDFViewer = props => {
  const [numPages, setNumPages] = React.useState(null);
  React.useEffect(() => {
    reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = props.workerSrc ? props.workerSrc : `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${reactPdf.pdfjs.version}/pdf.worker.js`;
  }, []);
  function onDocumentLoadSuccess({
    numPages
  }) {
    setNumPages(numPages);
  }
  const arr = [];
  for (let i = 1; i <= numPages; i++) {
    arr.push(i);
  }
  return /*#__PURE__*/React__default["default"].createElement(react.Box, null, /*#__PURE__*/React__default["default"].createElement("script", {
    src: "/js/pdfobject.js"
  }), /*#__PURE__*/React__default["default"].createElement(reactPdf.Document, _extends$2({
    file: props.file,
    onLoadSuccess: onDocumentLoadSuccess,
    options: {
      workerSrc: '/pdf.worker.js'
    },
    onLoadError: console.error
  }, props.documentProps), arr.map((page, index) => {
    return /*#__PURE__*/React__default["default"].createElement(reactPdf.Page, _extends$2({
      key: `pdf_page_${index}`,
      pageNumber: page
    }, props.pageProps));
  })));
};
PDFViewer.propTypes = {
  file: PropTypes__default["default"].node,
  workerSrc: PropTypes__default["default"].string,
  documentProps: PropTypes__default["default"].object,
  pageProps: PropTypes__default["default"].object
};

function DotMenu(props) {
  return /*#__PURE__*/React__default["default"].createElement(react.Menu, null, /*#__PURE__*/React__default["default"].createElement(react.MenuButton, {
    as: react.IconButton,
    "aria-label": "Options",
    icon: props.icon,
    variant: "link"
  }), /*#__PURE__*/React__default["default"].createElement(react.MenuList, {
    padding: 0
  }, props.menuDataItem && props.menuDataItem.map((menuData, index) => {
    return /*#__PURE__*/React__default["default"].createElement(react.MenuItem, _extends$2({
      key: `${index}-menudata`
    }, menuData, {
      height: '50px',
      fontSize: '16px'
    }));
  })));
}
DotMenu.propTypes = {
  icon: PropTypes__default["default"].element,
  menuDataItem: PropTypes__default["default"].array // [{children: <EmailIcon/> email},{children: 'profile',onClick: () =>}]
};
DotMenu.defaultProps = {
  icon: /*#__PURE__*/React__default["default"].createElement(DotMenuIcon, null)
};

/**
 * @deprecated - Use CQReactTable
 * @param {*} props
 * @returns
 */
function CQTable(props) {
  const {
    columnData,
    rowData,
    UpIcon,
    DownIcon,
    round,
    tableContainerProps,
    tableProps,
    commonCellProps,
    commonRowProps
  } = props;
  const [selectedRows, setSelectedRows] = React.useState([]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = reactTable.useTable({
    columns: React.useMemo(() => [...columnData], [columnData]),
    data: React.useMemo(() => [...rowData], [rowData])
  }, reactTable.useSortBy, reactTable.useResizeColumns, reactTable.useBlockLayout);
  const descIcon = DownIcon;
  const upIcon = UpIcon;
  const onRowSelect = (event, index) => {
    let temp = [];
    temp = selectedRows;
    if (!selectedRows.includes(index)) {
      temp.push(index);
      setSelectedRows([...temp]);
      props.onSelectRows && props.onSelectRows(temp);
    } else {
      const temp = selectedRows.filter(r => r !== index);
      setSelectedRows([...temp]);
      props.onSelectRows && props.onSelectRows(temp);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(react.Box, _extends$2({
    style: {
      ...props.tableStyle,
      borderRadius: round ? 10 : 0
    }
  }, tableContainerProps), /*#__PURE__*/React__default["default"].createElement(react.Table, _extends$2({}, getTableProps({
    style: {
      borderRadius: round ? 10 : 0
    }
  }), tableProps), /*#__PURE__*/React__default["default"].createElement(react.Thead, null, headerGroups.map(headerGroup => /*#__PURE__*/React__default["default"].createElement(react.Tr, _extends$2({}, commonRowProps, headerGroup.getHeaderGroupProps({
    style: {
      backgroundColor: props.headerColor,
      borderTopLeftRadius: round ? 10 : 0,
      borderTopRightRadius: round ? 10 : 0,
      width: '100%'
    }
  })), headerGroup.headers.map((column, i) => /*#__PURE__*/React__default["default"].createElement(react.Th, _extends$2({}, column.getHeaderProps({
    ...column.getSortByToggleProps(),
    isNumeric: column.isNumeric,
    style: {
      textTransform: 'none',
      textAlign: 'center',
      color: props.headerTextColor
    }
  }), props.specificHeaderProps ? props.specificHeaderProps[i] ? props.specificHeaderProps[i] : {} : {}), column.render('Header'), /*#__PURE__*/React__default["default"].createElement("span", null, column.isSorted ? column.isSortedDesc ? descIcon : upIcon : null)))))), /*#__PURE__*/React__default["default"].createElement(react.Tbody, getTableBodyProps({
    style: {
      borderBottomLeftRadius: round ? 10 : 0,
      borderBottomRightRadius: round ? 10 : 0,
      width: '100%'
    }
  }), rows.map((row, index) => {
    prepareRow(row);
    return /*#__PURE__*/React__default["default"].createElement(react.Tr, row.getRowProps({
      onClick: event => {
        props.rowSelect && onRowSelect && onRowSelect(event, index);
      },
      style: {
        textAlign: 'center',
        borderBottomWidth: 1,
        borderBottomLeftRadius: round && index + 1 === rows.length ? 10 : 0,
        borderBottomRightRadius: round && index + 1 === rows.length ? 10 : 0,
        background: selectedRows ? selectedRows.includes(index) ? props.selectedRowColor : row.original.color : row.original.color,
        width: '100%'
      }
    }), row.cells.map((cell, i) => {
      return /*#__PURE__*/React__default["default"].createElement(react.Td, _extends$2({}, cell.getCellProps({
        style: {
          textAlign: 'center',
          borderBottomRightRadius: round ? 10 : 0
        },
        isNumeric: cell.column.isNumeric
      }), commonCellProps, props.specificCellProps ? props.specificCellProps[i] ? props.specificCellProps[i] : {} : {}), cell.render('Cell'));
    }));
  }))));
}
CQTable.defaultProps = {
  headerColor: 'white',
  headerTextColor: 'black',
  selectedRowColor: LIGHT_BLUE,
  commonRowProps: {
    alignItems: 'center',
    borderBottomWidth: 1
  },
  commonCellProps: {
    borderBottomWidth: 0
  },
  selectRow: false
};
CQTable.propTypes = {
  columnData: PropTypes__default["default"].array,
  rowData: PropTypes__default["default"].array,
  onRowSelect: PropTypes__default["default"].func,
  onSelectRows: PropTypes__default["default"].func,
  UpIcon: PropTypes__default["default"].element,
  DownIcon: PropTypes__default["default"].element,
  headerColor: PropTypes__default["default"].string,
  tableStyle: PropTypes__default["default"].object,
  headerTextColor: PropTypes__default["default"].string,
  selectedRowColor: PropTypes__default["default"].string,
  round: PropTypes__default["default"].bool,
  tableProps: PropTypes__default["default"].object,
  tableContainerProps: PropTypes__default["default"].object,
  commonCellProps: PropTypes__default["default"].object,
  commonRowProps: PropTypes__default["default"].object,
  specificCellProps: PropTypes__default["default"].array,
  selectRow: PropTypes__default["default"].bool,
  specificHeaderProps: PropTypes__default["default"].array
};

const useCQMediaQuery = ({
  lg,
  md,
  sm
} = {}) => {
  const [isLargeScreen, isMediumScreen, isSmallScreen] = react.useMediaQuery(['(min-width:1600px)', '(min-width:1200px)', '(min-width:800px)']);
  if (isLargeScreen) {
    return lg;
  } else if (isMediumScreen) {
    return md;
  } else if (isSmallScreen) {
    return sm;
  }
  return sm;
};

/**
 * checks where the given object is a typeof function
 * @param {*} fn
 * @returns Boolean
 */
const isFunction = fn => fn && typeof fn === 'function';
const min = (a, b) => a > b ? b : a;

function CQReactTable(props) {
  const {
    LeftIcon: LeftIcon1,
    RightIcon: RightIcon1,
    onAsc,
    onDesc
  } = props;
  const tableWidth = useCQMediaQuery({
    lg: '100%',
    md: '100%',
    sm: 'max-content'
  });
  const [sorting, setSorting] = React__default["default"].useState([]);
  const [{
    pageIndex,
    pageSize
  }, setPagination] = React__default["default"].useState({
    pageIndex: props.currentPage ? props.currentPage - 1 : 0,
    pageSize: props.size ?? 10
  });
  const pagination = React__default["default"].useMemo(() => ({
    pageIndex,
    pageSize
  }), [pageIndex, pageSize]);
  const table = reactTable$1.useReactTable({
    data: props.data,
    columns: props.columns,
    state: {
      sorting,
      pagination
    },
    getCoreRowModel: props.getCoreRowModel ? props.getCoreRowModel() : reactTable$1.getCoreRowModel(),
    getSortedRowModel: reactTable$1.getSortedRowModel(),
    onSortingChange: setSorting,
    pageCount: props.pageCount,
    onPaginationChange: setPagination,
    manualPagination: props.manualPagination,
    manualSorting: props.manualSortBy,
    getPaginationRowModel: props.manualPagination ? null : reactTable$1.getPaginationRowModel() // If only doing manual pagination, you don’t need this
  });
  function handleNextPage() {
    table.nextPage();
    if (props.onNextPage) {
      props.onNextPage();
    }
  }
  function handlePreviousPage() {
    table.previousPage();
    if (props.onPreviousPage) {
      props.onPreviousPage();
    }
  }
  const handlePageChangeByNumber = clickedPageNumber => {
    table.setPageIndex(clickedPageNumber - 1);
    if (props.onPageChangeByNumber) {
      props.onPageChangeByNumber(clickedPageNumber);
    }
  };
  function handleSizeChange(n) {
    table.setPageSize(n);
    if (props.onSizeChange) {
      props.onSizeChange(n);
    }
  }
  function renderSortUpIcon() {
    if (props.renderSortUpIcon) {
      return props.renderSortUpIcon();
    }
    return /*#__PURE__*/React__default["default"].createElement(UpIcon, {
      style: {
        width: 10,
        height: 10,
        marginLeft: 1
      }
    });
  }
  function renderSortDownIcon() {
    if (props.renderSortDownIcon) {
      return props.renderSortDownIcon();
    }
    return /*#__PURE__*/React__default["default"].createElement(DownIcon, {
      style: {
        width: 10,
        height: 10,
        marginLeft: 1
      }
    });
  }
  function renderSortIcon(sortedValue, canSort = false, header) {
    if (!canSort) {
      return null;
    }
    if (sortedValue === 'asc') {
      if (onAsc) {
        onAsc(header);
      }
      return renderSortDownIcon();
    } else if (sortedValue === 'desc') {
      if (onDesc) {
        onDesc(header);
      }
      return renderSortUpIcon();
    }
    if (props.renderSortIcon) {
      return props.renderSortIcon();
    }
    return /*#__PURE__*/React__default["default"].createElement(SortIcon, {
      style: {
        width: 15,
        height: 15,
        marginLeft: 1
      }
    });
  }
  function renderLoader() {
    if (props.renderLoader) {
      return renderLoader();
    }
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => {
      return /*#__PURE__*/React__default["default"].createElement(react.Skeleton, {
        w: min(25 * i, 100) + '%',
        key: `audit-upload-loader-${i}`,
        mb: 2,
        h: 2,
        borderRadius: "sm"
      });
    });
  }
  function renderTable() {
    return /*#__PURE__*/React__default["default"].createElement(react.Table, _extends$2({
      width: tableWidth
    }, props.tableProps), /*#__PURE__*/React__default["default"].createElement(react.Thead, null, table.getHeaderGroups().map(headerGroup => {
      let headerProps = {};
      if (props.getHeaderProps) {
        headerProps = props.getHeaderProps(headerGroup);
      }
      return /*#__PURE__*/React__default["default"].createElement(react.Tr, _extends$2({
        key: headerGroup.id
      }, headerProps), headerGroup.headers.map(header => {
        const sortedValue = header.column.getIsSorted();
        const canSort = header.column.getCanSort();
        let headerCellProps = {};
        if (props.getHeaderCellProps) {
          headerCellProps = props.getHeaderCellProps(header.column);
        }
        delete headerCellProps.onClick;
        delete headerCellProps.cursor;
        let headerWrapperProps = {};
        if (props.getHeaderWrapperProps) {
          headerWrapperProps = props.getHeaderWrapperProps(header.column);
        }
        return /*#__PURE__*/React__default["default"].createElement(react.Th, _extends$2({
          key: header.id
        }, headerWrapperProps), header.isPlaceholder ? null : /*#__PURE__*/React__default["default"].createElement(react.HStack, _extends$2({
          onClick: header.column.getToggleSortingHandler(),
          cursor: canSort ? 'pointer' : 'inherit',
          justifyContent: 'center',
          alignItems: 'center',
          py: props.tableProps?.size === 'sm' ? 3 : 'inherit'
        }, headerCellProps), reactTable$1.flexRender(header.column.columnDef.header, header.getContext()), renderSortIcon(sortedValue, canSort, header.id)));
      }));
    })), /*#__PURE__*/React__default["default"].createElement(react.Tbody, null, table.getRowModel().rows.map(row => {
      let rowProps = {};
      if (props.getRowProps) {
        rowProps = props.getRowProps(row);
      }
      return /*#__PURE__*/React__default["default"].createElement(react.Tr, _extends$2({
        key: row.original[props.rowkey] || row.id
      }, rowProps), row.getVisibleCells().map(cell => {
        let cellProps = {};
        if (props.getCellProps) {
          cellProps = props.getCellProps(row, cell);
        }
        return /*#__PURE__*/React__default["default"].createElement(react.Td, _extends$2({
          key: cell.id
        }, cellProps), reactTable$1.flexRender(cell.column.columnDef.cell, cell.getContext()));
      }));
    })), /*#__PURE__*/React__default["default"].createElement(react.Tfoot, null, table.getFooterGroups().map(footerGroup => /*#__PURE__*/React__default["default"].createElement(react.Tr, {
      key: footerGroup.id
    }, footerGroup.headers.map(header => /*#__PURE__*/React__default["default"].createElement(react.Th, {
      key: header.id
    }, header.isPlaceholder ? null : reactTable$1.flexRender(header.column.columnDef.footer, header.getContext())))))));
  }
  function renderContent() {
    if (props.isLoading) {
      return renderLoader();
    }
    return renderTable();
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, renderContent(), props.total > 0 ? /*#__PURE__*/React__default["default"].createElement(react.Box, {
    w: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(CQPagination, {
    total: props.total,
    currentPage: props.currentPage,
    size: props.size,
    pageCount: props.pageCount,
    setCurrentPage: () => {},
    handlePageChangeByNumber: handlePageChangeByNumber,
    leftIcon: /*#__PURE__*/React__default["default"].createElement("button", {
      disabled: props.currentPage <= 1,
      onClick: handlePreviousPage,
      style: {
        marginRight: "2px"
      }
    }, LeftIcon1 || /*#__PURE__*/React__default["default"].createElement(LeftIcon, {
      style: {
        cursor: 'pointer',
        height: 40,
        width: 40
      }
    })),
    rightIcon: /*#__PURE__*/React__default["default"].createElement("button", {
      disabled: props.currentPage >= props.pageCount,
      onClick: handleNextPage,
      style: {
        marginLeft: "2px"
      }
    }, RightIcon1 || /*#__PURE__*/React__default["default"].createElement(RightIcon, {
      style: {
        cursor: 'pointer',
        height: 40,
        width: 40
      }
    })),
    sizeDropDown: props.total > 10 && props.onSizeChange && /*#__PURE__*/React__default["default"].createElement("select", {
      value: props.size,
      onChange: e => {
        handleSizeChange(Number(e.target.value));
      }
    }, [10, 20, 30, 40, 50].map(pageSize => pageSize <= props.total + 9 && /*#__PURE__*/React__default["default"].createElement("option", {
      key: pageSize,
      value: pageSize
    }, pageSize)))
  })) : null);
}
CQReactTable.defaultProps = {
  isLoading: false,
  currentPage: 1,
  size: 10,
  tableProps: {
    size: 'sm'
  },
  manualPagination: true,
  manualSortBy: false
};
CQReactTable.propTypes = {
  manualPagination: PropTypes__default["default"].bool,
  manualSortBy: PropTypes__default["default"].bool,
  isLoading: PropTypes__default["default"].bool,
  currentPage: PropTypes__default["default"].number,
  size: PropTypes__default["default"].number,
  total: PropTypes__default["default"].number,
  pageCount: PropTypes__default["default"].number,
  data: PropTypes__default["default"].array,
  columns: PropTypes__default["default"].array,
  UpIcon: PropTypes__default["default"].element,
  DownIcon: PropTypes__default["default"].element,
  tableProps: PropTypes__default["default"].object,
  onNextPage: PropTypes__default["default"].func,
  onPreviousPage: PropTypes__default["default"].func,
  onPageChangeByNumber: PropTypes__default["default"].func,
  renderSortUpIcon: PropTypes__default["default"].func,
  renderSortDownIcon: PropTypes__default["default"].func,
  renderSortIcon: PropTypes__default["default"].func,
  renderLoader: PropTypes__default["default"].func,
  getHeaderCellProps: PropTypes__default["default"].func,
  getRowProps: PropTypes__default["default"].func,
  getCellProps: PropTypes__default["default"].func,
  LeftIcon: PropTypes__default["default"].element,
  RightIcon: PropTypes__default["default"].element,
  onAsc: PropTypes__default["default"].func,
  onDesc: PropTypes__default["default"].func,
  getHeaderProps: PropTypes__default["default"].func,
  getHeaderWrapperProps: PropTypes__default["default"].func
};

const H1 = 'h1';
const H2 = 'h2';
const H3 = 'h3';
const H4 = 'h4';
const H5 = 'h5';
const H6 = 'h6';

function Heading(props) {
  const variant = {
    [H1]: {
      fontSize: '36px',
      as: 'h1'
    },
    [H2]: {
      fontSize: '30px',
      as: 'h2'
    },
    [H3]: {
      fontSize: '28px',
      as: 'h3'
    },
    [H4]: {
      fontSize: '24px',
      as: 'h4'
    },
    [H5]: {
      fontSize: '18px',
      as: 'h5'
    },
    [H6]: {
      fontSize: '16px',
      as: 'h6'
    }
  };
  const customProps = props.variant ? variant[props.variant] : variant[H1];
  return /*#__PURE__*/React__default["default"].createElement(react.Heading, _extends$2({}, customProps, props));
}
Heading.propTypes = {
  variant: PropTypes__default["default"].oneOf([H1, H2, H3, H4, H5, H6])
};

function PasswordInput(props) {
  const {
    passwordShowIcon,
    passwordHideIcon,
    wrapperProps,
    leftIcon,
    leftIconProps,
    passwordIconProps,
    isInvalid,
    errorText,
    errorTextStyle,
    ...rest
  } = props;
  const [show, setShow] = React.useState(false);
  const passwordShowIconData = passwordShowIcon || /*#__PURE__*/React__default["default"].createElement(EyeHiddenIcon, null);
  const passwordHideIconData = passwordHideIcon || /*#__PURE__*/React__default["default"].createElement(EyeIcon, null);
  return /*#__PURE__*/React__default["default"].createElement(react.FormControl, null, /*#__PURE__*/React__default["default"].createElement(react.InputGroup, _extends$2({
    bgColor: WHITE_COLOR
  }, wrapperProps), leftIcon && /*#__PURE__*/React__default["default"].createElement(react.InputLeftElement, _extends$2({
    pointerEvents: "none"
  }, leftIconProps, {
    children: leftIcon
  })), /*#__PURE__*/React__default["default"].createElement(react.Input, _extends$2({
    errorBorderColor: DANGER,
    type: show ? 'text' : 'password'
  }, rest)), /*#__PURE__*/React__default["default"].createElement(react.InputRightElement, _extends$2({
    cursor: 'pointer'
  }, passwordIconProps, {
    onClick: () => setShow(prev => !prev),
    children: show ? passwordHideIconData : passwordShowIconData
  }))), isInvalid && /*#__PURE__*/React__default["default"].createElement(react.Text, {
    color: DANGER,
    style: {
      ...errorTextStyle
    }
  }, errorText));
}
const FormPasswordInput = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
  const controller = reactHookForm.useController({
    control: props.control,
    defaultValue: '',
    name: props.name
  });
  const handleChange = e => {
    if (props.onChange) {
      props.onChange(e);
    }
    controller.field.onChange(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(PasswordInput, _extends$2({
    ref: ref,
    value: controller.field.value,
    isInvalid: controller.fieldState?.error?.message,
    errorText: controller.fieldState?.error?.message
  }, props, {
    onChange: handleChange
  }));
});
FormPasswordInput.displayName = 'FormPasswordInput';
PasswordInput.propTypes = {
  id: PropTypes__default["default"].string,
  placeholder: PropTypes__default["default"].string,
  size: PropTypes__default["default"].string,
  leftIcon: PropTypes__default["default"].element,
  leftIconProps: PropTypes__default["default"].object,
  passwordShowIcon: PropTypes__default["default"].element,
  passwordHideIcon: PropTypes__default["default"].element,
  passwordIconProps: PropTypes__default["default"].object,
  errorText: PropTypes__default["default"].string,
  errorTextStyle: PropTypes__default["default"].object,
  wrapperProps: PropTypes__default["default"].object,
  onChange: PropTypes__default["default"].func
};
FormPasswordInput.propTypes = {
  id: PropTypes__default["default"].string,
  placeholder: PropTypes__default["default"].string,
  size: PropTypes__default["default"].string,
  leftIcon: PropTypes__default["default"].element,
  leftIconProps: PropTypes__default["default"].object,
  passwordShowIcon: PropTypes__default["default"].element,
  passwordHideIcon: PropTypes__default["default"].element,
  passwordIconProps: PropTypes__default["default"].object,
  control: PropTypes__default["default"].object,
  name: PropTypes__default["default"].string,
  wrapperProps: PropTypes__default["default"].object,
  errorTextStyle: PropTypes__default["default"].object,
  onChange: PropTypes__default["default"].func
};

const Checkbox = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
  return /*#__PURE__*/React__default["default"].createElement(react.Checkbox, _extends$2({
    ref: ref,
    size: props.size,
    colorScheme: props.colorScheme
  }, props));
});
Checkbox.propTypes = {
  size: PropTypes__default["default"].string,
  colorScheme: PropTypes__default["default"].string
};
Checkbox.defaultProps = {
  size: 'md',
  colorScheme: BLACK
};

function ConfirmationPopUp(props) {
  return /*#__PURE__*/React__default["default"].createElement(react.Modal, {
    isOpen: props.isOpen,
    size: props.size,
    onClose: props.onClose
  }, /*#__PURE__*/React__default["default"].createElement(react.ModalOverlay, null), /*#__PURE__*/React__default["default"].createElement(react.ModalContent, {
    p: 10,
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.ModalHeader, {
    style: {
      color: '#023B93',
      fontSize: '25px'
    }
  }, /*#__PURE__*/React__default["default"].createElement("center", null, props.title)), /*#__PURE__*/React__default["default"].createElement(react.ModalBody, {
    mb: 2
  }, /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    variant: "outline",
    mr: 3,
    borderRadius: 20,
    style: {
      fontWeight: 500,
      outline: 'solid',
      paddingInline: '35px'
    },
    pl: 17,
    pr: 17
  }, props.button)), /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    mr: 3,
    borderRadius: 20,
    style: {
      fontWeight: 500,
      outline: 'solid',
      minWidth: '40',
      paddingInline: '35px'
    }
  }, props.closeButton))), props.text && /*#__PURE__*/React__default["default"].createElement("span", {
    className: "m-5",
    style: {
      fontSize: '13px'
    }
  }, /*#__PURE__*/React__default["default"].createElement("center", null, props.text))));
}
ConfirmationPopUp.propTypes = {
  size: PropTypes__default["default"].string,
  isOpen: PropTypes__default["default"].bool,
  onClose: PropTypes__default["default"].bool,
  text: PropTypes__default["default"].string,
  title: PropTypes__default["default"].string,
  button: PropTypes__default["default"].object,
  // buttonProps: PropTypes.object,
  closeButton: PropTypes__default["default"].object
};

/* eslint-disable no-template-curly-in-string */
function equalTo(ref, msg) {
  return this.test({
    name: 'equalTo',
    exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
    params: {
      reference: ref.path
    },
    test: function (value) {
      return value === this.resolve(ref);
    }
  });
}
yup__namespace.addMethod(yup__namespace.string, 'equalTo', equalTo);
const FORGOT_PASSWORD_SCHEMA = yup__namespace.object({
  email: yup__namespace.string().required('Email is required').email('must have Email format')
});
const RESET_SCHEMA = yup__namespace.object({
  newPassword: yup__namespace.string().required('New Password is required').min(8, 'Password must be at least 8 characters').max(25, 'Password must be less than 25 characters').matches(/[A-Z]/, 'Password must contain one uppercase').matches(/([a-z])/, 'Password must contain one lowercase').matches(/(\d)/, 'Password must contain one number').matches(/(\W)/, 'Password must contain one special character'),
  confirmPassword: yup__namespace.string().required('Confirm Password is required').equalTo(yup__namespace.ref('newPassword'), 'Confirm Password must be same as New Password')
});

const FONT_FAMILY = {
  baiJamurjee: 'Bai Jamjuree',
  ptSans: 'PT Sans'
};

const CQForgotPassword = ({
  onForgotPassword,
  isSubmitting,
  title,
  description,
  buttonName,
  emailProps,
  buttonProps,
  forgotPasswordSchema
}) => {
  const handleForgotPassword = async formData => {
    const {
      email
    } = formData;
    await onForgotPassword(email);
  };
  const form = reactHookForm.useForm({
    resolver: yup$1.yupResolver(forgotPasswordSchema ? yup__namespace.object(forgotPasswordSchema) : FORGOT_PASSWORD_SCHEMA)
  });
  const {
    control,
    handleSubmit
  } = form;
  return /*#__PURE__*/React__default["default"].createElement(react.VStack, {
    flex: 1,
    style: {
      marginTop: 45,
      marginBottom: 45
    },
    borderRadius: '3xl',
    bgColor: LOGINFORMBG,
    justifyContent: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    p: '15%',
    w: '100%',
    justifyContent: 'center',
    textAlign: 'center',
    ml: 4
  }, /*#__PURE__*/React__default["default"].createElement(react.Heading, {
    color: SECONDARY,
    fontSize: '2xl'
  }, title), /*#__PURE__*/React__default["default"].createElement(react.Text, {
    pb: 4,
    textAlign: 'center',
    fontFamily: FONT_FAMILY.ptSans
  }, description), /*#__PURE__*/React__default["default"].createElement("form", {
    onSubmit: handleSubmit(handleForgotPassword)
  }, /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    width: '100%',
    flexDirection: 'column'
  }, /*#__PURE__*/React__default["default"].createElement(FormTextInput, _extends$2({
    name: "email",
    control: control,
    id: "email",
    placeholder: "Email",
    leftIcon: /*#__PURE__*/React__default["default"].createElement(MailIcon, null),
    size: "md"
  }, emailProps)), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    pt: 4
  }), /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    spacing: 6
  }, /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    isLoading: isSubmitting,
    type: "submit",
    bgColor: PRIMARY,
    variant: 'solid',
    fontFamily: FONT_FAMILY.baiJamurjee,
    fontWeight: 'semibold',
    color: "white"
  }, buttonProps), buttonName))))));
};
CQForgotPassword.propTypes = {
  onForgotPassword: PropTypes__default["default"].func,
  isSubmitting: PropTypes__default["default"].bool,
  title: PropTypes__default["default"].string,
  description: PropTypes__default["default"].string,
  buttonName: PropTypes__default["default"].string,
  emailProps: FormTextInput.propTypes,
  buttonProps: PropTypes__default["default"].object,
  forgotPasswordSchema: PropTypes__default["default"].object
};
CQForgotPassword.defaultProps = {
  title: 'Forgot Password',
  description: 'Enter your email address to request a password reset.',
  buttonName: 'Submit'
};

/* eslint-disable react/no-unescaped-entities */

const CQForgotPasswordMessage = ({
  forgotPasswordEmail,
  onForgotPassword,
  formServerError
}) => {
  const forgotPassword = async () => {
    if (forgotPasswordEmail) {
      await onForgotPassword(forgotPasswordEmail);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(react.VStack, {
    flex: 1,
    style: {
      marginTop: 45,
      marginBottom: 45
    },
    borderRadius: '3xl',
    bgColor: LOGINFORMBG,
    justify: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    pl: 8 + 8,
    pr: 8,
    w: '100%',
    textAlign: 'center',
    fontSize: '16px'
  }, !formServerError ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    textAlign: 'center',
    fontSize: '16px'
  }, "A password reset link has been sent to", ' '), /*#__PURE__*/React__default["default"].createElement(react.Text, {
    textAlign: 'center',
    color: SECONDARY,
    fontWeight: 'bold',
    pb: 5
  }, forgotPasswordEmail), /*#__PURE__*/React__default["default"].createElement(react.Text, {
    textAlign: 'center'
  }, "If you don't receive an email"), /*#__PURE__*/React__default["default"].createElement(react.HStack, {
    justifyContent: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    color: SECONDARY,
    fontWeight: 'bold',
    style: {
      cursor: 'pointer'
    },
    onClick: () => forgotPassword()
  }, "click here"), /*#__PURE__*/React__default["default"].createElement(react.Text, null, " to have another email sent"))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    textAlign: 'center'
  }, formServerError || 'Something went wrong'), /*#__PURE__*/React__default["default"].createElement(react.HStack, {
    justifyContent: "center"
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    color: SECONDARY,
    fontWeight: 'bold',
    style: {
      cursor: 'pointer'
    },
    onClick: () => forgotPassword()
  }, "Click here"), /*#__PURE__*/React__default["default"].createElement(react.Text, null, "to try again")))));
};
CQForgotPasswordMessage.propTypes = {
  forgotPasswordEmail: PropTypes__default["default"].string,
  onForgotPassword: PropTypes__default["default"].func,
  formServerError: PropTypes__default["default"].string
};

const PasswordSrength = ({
  strength
}) => {
  return /*#__PURE__*/React__default["default"].createElement(react.HStack, {
    spacing: '6px',
    m: 1
  }, /*#__PURE__*/React__default["default"].createElement(react.Box, {
    bgColor: strength >= 1 ? SECONDARY : 'gray.200',
    height: '5px',
    width: "25%",
    borderRadius: 10
  }), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    bgColor: strength >= 2 ? SECONDARY : 'gray.200',
    height: '5px',
    width: "25%",
    borderRadius: 10
  }), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    bgColor: strength >= 3 ? SECONDARY : 'gray.200',
    height: '5px',
    width: "25%",
    borderRadius: 10
  }), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    bgColor: strength >= 4 ? SECONDARY : 'gray.200',
    height: '5px',
    width: "25%",
    borderRadius: 10
  }));
};

const strengthChecker = value => {
  let strength = 0;
  if (value.length > 4 && value.length < 8) {
    return 1;
  }
  if (value.length >= 8) {
    if (/[A-Z]/.test(value)) {
      strength++;
    }
    if (/([a-z])/.test(value)) {
      strength++;
    }
    if (/(\d)/.test(value)) {
      strength++;
    }
    if (/(\W)/.test(value)) {
      strength++;
    }
  }
  return strength;
};

const CQResetPassword = ({
  onResetPassword,
  isSubmitting,
  token,
  email,
  formServerError,
  title,
  description,
  buttonName,
  buttonProps,
  confirmPasswordProps,
  newPasswordProps,
  passwordSchema,
  sso_microsoft,
  sso_microsoft_button_props
}) => {
  const [passwordStrength, setPasswordStrength] = React.useState(0);
  const handleReset = async formData => {
    const {
      newPassword
    } = formData;
    onResetPassword({
      password: newPassword,
      token,
      email
    });
  };
  const form = reactHookForm.useForm({
    resolver: yup$1.yupResolver(passwordSchema ? yup__namespace.object(passwordSchema) : RESET_SCHEMA)
  });
  const {
    control,
    handleSubmit
  } = form;
  return /*#__PURE__*/React__default["default"].createElement(react.VStack, {
    flex: 1,
    style: {
      marginTop: 45,
      marginBottom: 45
    },
    borderRadius: '3xl',
    bgColor: LOGINFORMBG,
    justify: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    pl: 8 + 8,
    pr: 8,
    w: '100%',
    textAlign: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Heading, {
    color: SECONDARY,
    fontSize: '2xl'
  }, title), /*#__PURE__*/React__default["default"].createElement(react.Text, null, description, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: SECONDARY,
      fontWeight: 'bold'
    }
  }, " ", email)), formServerError && /*#__PURE__*/React__default["default"].createElement(react.Text, {
    fontWeight: 'bold',
    color: 'red.400'
  }, formServerError), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    pt: 4
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    onSubmit: handleSubmit(handleReset)
  }, /*#__PURE__*/React__default["default"].createElement(FormPasswordInput, _extends$2({
    control: control,
    name: "newPassword",
    id: "newPassword",
    placeholder: "New Password",
    leftIcon: /*#__PURE__*/React__default["default"].createElement(LockIcon, null),
    passwordShowIcon: /*#__PURE__*/React__default["default"].createElement(EyeHiddenIcon, null),
    passwordHideIcon: /*#__PURE__*/React__default["default"].createElement(EyeIcon, null),
    size: "md",
    onChange: e => {
      const value = strengthChecker(e.target.value);
      setPasswordStrength(value);
    }
  }, newPasswordProps)), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    pt: 4
  }), /*#__PURE__*/React__default["default"].createElement(FormPasswordInput, _extends$2({
    control: control,
    name: "confirmPassword",
    id: "confirmPassword",
    placeholder: "Confirm Password",
    leftIcon: /*#__PURE__*/React__default["default"].createElement(LockIcon, null),
    passwordShowIcon: /*#__PURE__*/React__default["default"].createElement(EyeHiddenIcon, null),
    passwordHideIcon: /*#__PURE__*/React__default["default"].createElement(EyeIcon, null),
    size: "md"
  }, confirmPasswordProps)), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    pt: 2
  }), /*#__PURE__*/React__default["default"].createElement(react.HStack, {
    alignContent: "flex-start",
    ml: 1
  }, /*#__PURE__*/React__default["default"].createElement(react.Text, {
    fontSize: 'sm'
  }, "Password Strength")), /*#__PURE__*/React__default["default"].createElement(PasswordSrength, {
    strength: passwordStrength
  }), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    pt: 8
  }), /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    spacing: 6
  }, /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    isLoading: isSubmitting,
    type: "submit",
    bgColor: PRIMARY,
    variant: 'solid',
    fontFamily: FONT_FAMILY.baiJamurjee,
    fontWeight: 'semibold',
    color: "white"
  }, buttonProps), buttonName))), !!sso_microsoft && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(react.Box, {
    position: "relative",
    textAlign: "center",
    pt: 5,
    pb: 5
  }, /*#__PURE__*/React__default["default"].createElement(react.Divider, {
    borderColor: "gray.300"
  }), /*#__PURE__*/React__default["default"].createElement(react.Text, {
    as: "span",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bg: "white",
    px: 4,
    fontSize: "sm",
    color: "gray.500",
    zIndex: 1
  }, "OR")), /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    isLoading: isSubmitting,
    type: "submit",
    bgColor: SECONDARY,
    variant: 'solid',
    fontFamily: FONT_FAMILY.baiJamurjee,
    fontWeight: 'semibold',
    color: "white"
  }, sso_microsoft_button_props), "Sign up with Microsoft"))));
};
CQResetPassword.propTypes = {
  onResetPassword: PropTypes__default["default"].func,
  isSubmitting: PropTypes__default["default"].bool,
  token: PropTypes__default["default"].string,
  email: PropTypes__default["default"].string,
  formServerError: PropTypes__default["default"].string,
  title: PropTypes__default["default"].string,
  description: PropTypes__default["default"].string,
  buttonName: PropTypes__default["default"].string,
  newPasswordProps: FormPasswordInput.propTypes,
  confirmPasswordProps: FormPasswordInput.propTypes,
  buttonProps: PropTypes__default["default"].object,
  passwordSchema: PropTypes__default["default"].object,
  sso_microsoft: PropTypes__default["default"].bool,
  sso_microsoft_button_props: PropTypes__default["default"].object
};
CQResetPassword.defaultProps = {
  title: 'Reset Password',
  description: 'Enter New Password for',
  buttonName: 'Submit',
  sso_microsoft: false
};

const CQResetPasswordMessage = ({
  buttonName,
  buttonOnClick,
  buttonProps,
  message,
  icon,
  messageProps,
  descriptionProps,
  descriptionLine1,
  descriptionLine2
}) => {
  const iconComponent = icon || /*#__PURE__*/React__default["default"].createElement(MarkIcon, null);
  return /*#__PURE__*/React__default["default"].createElement(react.VStack, {
    flex: 1,
    style: {
      marginTop: 45,
      marginBottom: 45
    },
    borderRadius: '3xl',
    bgColor: LOGINFORMBG,
    justify: 'center'
  }, /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    pl: 8 + 8,
    pr: 8,
    w: '100%',
    textAlign: 'center',
    fontSize: '16px'
  }, /*#__PURE__*/React__default["default"].createElement(react.Center, null, iconComponent), /*#__PURE__*/React__default["default"].createElement(react.Text, _extends$2({
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 500,
    color: SECONDARY,
    fontFamily: FONT_FAMILY.baiJamurjee
  }, messageProps), message), /*#__PURE__*/React__default["default"].createElement(react.Text, _extends$2({
    textAlign: 'center',
    fontSize: '16px'
  }, descriptionProps), descriptionLine1, /*#__PURE__*/React__default["default"].createElement("br", null), " ", descriptionLine2), /*#__PURE__*/React__default["default"].createElement(react.Box, {
    pl: 7
  }), /*#__PURE__*/React__default["default"].createElement(react.Stack, {
    spacing: 6
  }, /*#__PURE__*/React__default["default"].createElement(react.Button, _extends$2({
    bgColor: PRIMARY,
    variant: 'solid',
    fontWeight: 'semibold',
    fontFamily: FONT_FAMILY.baiJamurjee,
    onClick: buttonOnClick,
    color: "white"
  }, buttonProps), buttonName))));
};
CQResetPasswordMessage.propTypes = {
  buttonName: PropTypes__default["default"].string,
  buttonOnClick: PropTypes__default["default"].func,
  buttonProps: PropTypes__default["default"].object,
  message: PropTypes__default["default"].string,
  icon: PropTypes__default["default"].element,
  messageProps: PropTypes__default["default"].object,
  descriptionProps: PropTypes__default["default"].object,
  descriptionLine1: PropTypes__default["default"].string,
  descriptionLine2: PropTypes__default["default"].string
};
CQResetPasswordMessage.defaultProps = {
  buttonName: 'Login',
  buttonOnClick: () => {
    console.log('clicked');
  },
  message: 'Successful password reset!',
  descriptionLine1: 'You can now use your new password',
  descriptionLine2: 'to log in to your account'
};

/**
 * BooleanStateProps.
 * @typedef {Object} BooleanStateProps
 * @property {function} on - Turns on the state.
 * @property {function} off - Turns off the state.
 * @property {function} toggle - Toggles between the state.
 */

/**
 * Handy way to handle boolean states
 * @param {boolean} initialValue
 * @returns {[boolean, BooleanStateProps]}
 */
const useBoolean = (initialValue = false) => {
  const [boolState, setBoolState] = React__default["default"].useState(initialValue);

  /** @type {BooleanStateProps} */
  const updateBoolState = {
    on: () => setBoolState(true),
    off: () => setBoolState(false),
    toggle: () => setBoolState(!boolState)
  };
  return [boolState, updateBoolState];
};

function useToastr() {
  const toast = react.useToast();
  const showSuccess = props => {
    const {
      headerProps,
      descriptionProps
    } = props;
    const icon = props.icon || /*#__PURE__*/React__default["default"].createElement(SuccessToastIcon, null);
    toast({
      description: 'Operation success',
      status: 'success',
      position: 'top-right',
      duration: 9000,
      isClosable: true,
      render: ({
        onClose
      }) => {
        return /*#__PURE__*/React__default["default"].createElement(react.Box, {
          borderColor: PRIMARY,
          borderWidth: 'medium',
          borderRadius: 'xl',
          p: 3,
          bg: "white",
          fontFamily: FONT_FAMILY.ptSans,
          onClick: onClose,
          cursor: "pointer"
        }, /*#__PURE__*/React__default["default"].createElement(react.HStack, null, /*#__PURE__*/React__default["default"].createElement(react.Box, null, /*#__PURE__*/React__default["default"].createElement(react.Text, _extends$2({
          color: SECONDARY,
          fontSize: 'xl',
          fontWeight: "extrabold",
          fontFamily: FONT_FAMILY.baiJamurjee
        }, headerProps), props.header), /*#__PURE__*/React__default["default"].createElement(react.Text, _extends$2({
          color: SECONDARY,
          fontFamily: FONT_FAMILY.ptSans,
          fontSize: 'sm'
        }, descriptionProps), props.description)), /*#__PURE__*/React__default["default"].createElement(react.Spacer, null), icon));
      },
      ...props
    });
  };
  const showLoading = props => {
    const {
      loadingProps,
      loadingText,
      isLoading
    } = props;
    const icon = props.icon || /*#__PURE__*/React__default["default"].createElement(react.Spinner, {
      color: SECONDARY
    });
    if (isLoading) {
      toast({
        status: 'success',
        position: 'top-right',
        isClosable: true,
        render: ({
          onClose
        }) => /*#__PURE__*/React__default["default"].createElement(react.Box, {
          borderColor: PRIMARY,
          borderWidth: 'medium',
          borderRadius: 'xl',
          p: 3,
          bg: "white",
          fontFamily: FONT_FAMILY.ptSans,
          onClick: onClose,
          cursor: "pointer"
        }, /*#__PURE__*/React__default["default"].createElement(react.HStack, null, icon, /*#__PURE__*/React__default["default"].createElement(react.Text, _extends$2({
          color: SECONDARY,
          fontFamily: FONT_FAMILY.ptSans,
          fontSize: 'sm'
        }, loadingProps), loadingText))),
        ...props,
        duration: null,
        id: 'loading-toast'
      });
    } else {
      toast.close('loading-toast');
    }
  };
  const showError = props => {
    toast({
      description: 'Operation failed',
      position: 'top-right',
      status: 'error',
      duration: 5000,
      isClosable: true,
      ...props
    });
  };
  const showWarning = props => {
    toast({
      description: 'Internet error! Check your connection',
      position: 'top-right',
      status: 'warning',
      duration: 5000,
      isClosable: true,
      ...props
    });
  };
  const showInfo = props => {
    toast({
      description: 'Something went wrong. ',
      position: 'top-right',
      status: 'info',
      duration: 5000,
      isClosable: true,
      ...props
    });
  };
  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showLoading
  };
}
useToastr.PropTypes = {
  description: PropTypes__default["default"].string,
  header: PropTypes__default["default"].string,
  headerProps: PropTypes__default["default"].object,
  descriptionProps: PropTypes__default["default"].object,
  icon: PropTypes__default["default"].element,
  loadingText: PropTypes__default["default"].string,
  loadingProps: PropTypes__default["default"].object,
  isLoading: PropTypes__default["default"].bool
};

const usePaginationSessionStorage = () => {
  const generateKey = (pageName, tableName) => `${pageName}_${tableName}_pagination`;

  // Save pagination parameter depend on page name and table name
  const setPaginationSession = (pageName, tableName, paginationParams) => {
    if (pageName && tableName && paginationParams) {
      const key = generateKey(pageName, tableName);
      if (paginationParams.hasOwnProperty('ordering')) {
        delete paginationParams['ordering'];
      }
      sessionStorage.setItem(key, JSON.stringify(paginationParams));
    }
  };

  // Retrieve pagination parameter depend on page name and table name
  const getPaginationSession = (pageName, tableName) => {
    if (pageName && tableName) {
      const key = generateKey(pageName, tableName);
      const paginationParams = sessionStorage.getItem(key);
      return paginationParams ? JSON.parse(paginationParams) : null;
    } else {
      return null;
    }
  };
  return {
    setPaginationSession,
    getPaginationSession
  };
};

const paginationReturnType = {
  loadNext: async function () {},
  loadPrevious: async function () {},
  loadAPI: async function () {},
  totalPage: 1,
  totalCount: 1,
  showSize: 1,
  currentPage: 1,
  showOrdering: '',
  setParams: () => {}
};
const DEFAULT_PAGE_SIZE = 10;
const usePagination = (apiFn, size) => {
  const {
    setPaginationSession,
    getPaginationSession
  } = usePaginationSessionStorage();
  const [paginationParams, setPaginationParams] = React__default["default"].useState({
    page: 1,
    totalPages: 1,
    size: size || DEFAULT_PAGE_SIZE,
    totalCount: 0,
    ordering: ''
  });
  async function loadNext(pageName = null, tableName = null) {
    return await loadPageByNumber(pageName, tableName, paginationParams.page + 1);
  }
  async function loadPrevious(pageName = null, tableName = null) {
    return await loadPageByNumber(pageName, tableName, paginationParams.page - 1);
  }
  async function loadSize(pageName = null, tableName = null, size) {
    if (!isFunction(apiFn)) {
      return;
    }
    if (size > paginationParams.totalCount + 9 || size === paginationParams.size) {
      return;
    }
    const paginationQuery = {
      page: 1,
      size: size
    };
    if (paginationParams.ordering) {
      paginationQuery.ordering = paginationParams.ordering;
    }
    let updatedPaginationParams = {
      ...paginationParams,
      size: size,
      page: 1,
      totalPages: Math.ceil(paginationParams.totalCount / size) || 1
    };
    setPaginationParams(updatedPaginationParams);
    const response = await apiFn(paginationQuery);
    updatedPaginationParams = {
      ...updatedPaginationParams,
      totalPages: Math.ceil(response?.count / size) || 1
    };
    setPaginationParams(updatedPaginationParams);
    setPaginationSession(pageName, tableName, updatedPaginationParams);
    return response?.results || [];
  }
  async function loadAPI(pageName = null, tableName = null, searching = false) {
    if (!isFunction(apiFn)) {
      return;
    }
    const sessionPaginationParam = getPaginationSession(pageName, tableName);
    const {
      page = paginationParams.page,
      size = paginationParams.size
    } = searching ? {
      page: 1,
      size: 10
    } : sessionPaginationParam || {};
    const paginationQuery = {
      page,
      size
    };
    if (paginationParams.ordering) {
      paginationQuery.ordering = paginationParams.ordering;
    }
    const response = await apiFn(paginationQuery);
    const updatedPaginationParams = {
      ...paginationParams,
      page,
      size,
      totalPages: Math.ceil(response?.count / size) || 1,
      totalCount: response?.count
    };
    setPaginationParams(updatedPaginationParams);
    setPaginationSession(pageName, tableName, {
      ...updatedPaginationParams
    });
    return response?.results || [];
  }
  async function loadPageByNumber(pageName = null, tableName = null, pageNumber) {
    if (!isFunction(apiFn)) {
      return;
    }
    if (pageNumber > paginationParams.totalPages || pageNumber <= 0) {
      return;
    }
    const paginationQuery = {
      page: pageNumber,
      size: paginationParams.size
    };
    if (paginationParams.ordering) {
      paginationQuery.ordering = paginationParams.ordering;
    }
    const updatedPaginationParams = {
      ...paginationParams,
      page: pageNumber
    };
    setPaginationParams(updatedPaginationParams);
    setPaginationSession(pageName, tableName, {
      ...updatedPaginationParams
    });
    const response = await apiFn(paginationQuery);
    updatedPaginationParams = {
      ...updatedPaginationParams,
      totalPages: Math.ceil(response?.count / updatedPaginationParams.size) || 1
    };
    setPaginationParams(updatedPaginationParams);
    setPaginationSession(pageName, tableName, updatedPaginationParams);
    return response?.results || [];
  }
  return {
    loadNext,
    loadPrevious,
    loadPageByNumber,
    loadAPI,
    loadSize,
    totalPage: paginationParams.totalPages,
    totalCount: paginationParams.totalCount,
    showSize: paginationParams.size,
    currentPage: paginationParams.page,
    showOrdering: paginationParams.ordering,
    setParams: params => setPaginationParams({
      ...paginationParams,
      ...params
    })
  };
};

const useScrollPosition = () => {
  /**
   * Custom React hook to manage and restore scroll position for a specific table or element.
   * 
   * Usage:
   * 1. Import the hook into your component: `import { useScrollPosition } from './path/to/your/hook';`
   * 2. Call the hook inside your functional component: `const { tableRef, scrollPosition } = useScrollPosition();`
   * 3. Attach the `tableRef` to the element you want to manage scroll position for.
   * 4. Use `scrollPosition.save(id)` to save the scroll position (where `id` is a unique identifier for the row or element).
   * 5. The hook will automatically restore the scroll position when the component mounts and the saved position is available in session storage.
   */

  const key = window.location.pathname + "_scroll_position";
  const tableRef = React__default["default"].useRef(null);
  React__default["default"].useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (tableRef.current) {
        const savedPosition = sessionStorage.getItem(key);
        const rowElement = tableRef.current.querySelector(`[data-key='${savedPosition}']`);
        if (savedPosition && rowElement) {
          rowElement?.scrollIntoView({
            behavior: 'smooth'
          });
          sessionStorage.removeItem(key); // Remove after using once
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [tableRef.current]);
  const scrollPosition = {
    save: id => sessionStorage.setItem(key, id)
  };
  return {
    tableRef,
    scrollPosition
  };
};

function useTabStorage() {
  const key = window.location.pathname + "_tab_storage";
  const tabStorage = {
    setTab: tabLocation => sessionStorage.setItem(key, tabLocation),
    getTab: () => {
      const tab = sessionStorage.getItem(key);
      const parsedTab = parseInt(tab, 10);
      return isNaN(parsedTab) ? 0 : parsedTab;
    }
  };
  return tabStorage;
}

const useClickHistorySessionStorage = () => {
  const DASHBOARD_CLICK_HISTORY = 'dashboard_click_history';
  const setDashboardTilesClickHistorySession = tilesClickDictionary => {
    sessionStorage.setItem(DASHBOARD_CLICK_HISTORY, JSON.stringify(tilesClickDictionary));
  };
  const getDashboardTilesClickHistorySession = () => {
    return JSON.parse(sessionStorage.getItem(DASHBOARD_CLICK_HISTORY));
  };
  const increaseDashboardTilesClickHistorySessionbyTileId = tileId => {
    const clickHistory = getDashboardTilesClickHistorySession();
    clickHistory[tileId] += 1;
    setDashboardTilesClickHistorySession(clickHistory);
  };
  return {
    setDashboardTilesClickHistorySession,
    getDashboardTilesClickHistorySession,
    increaseDashboardTilesClickHistorySessionbyTileId
  };
};

// contains tile name to id mapping
const TILES_NAME_TO_ID_MAPPING = {
  temperature_gauge: 0,
  ri_score: 1,
  rvu_opportunity: 2,
  outstanding_revenue_opportunity: 3,
  revenue_breakdown: 4,
  potential_revenue_breakdown: 5,
  uploaded_chart_activity: 6,
  total_charts: 7,
  providers: 8,
  // for non provider clients
  providers_chart_analytics: 9,
  // for provider level clients
  upload_breakdown: 10,
  sub_clients: 11
};

// a map (could have been a list, but for better visual representation) that maps tile id to tile details
const ID_TO_TILES_FULL_DETAILS = {
  0: ['Revenue Cycle Temperature Gauge', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Revenue Cycle Temperature Gauge"), " represents the overall health of your revenue cycle. High temperatures indicate potential compliance risks, while low temperatures suggest possible revenue leaks. You can set specific parameters in the 'Practice Info' tab to customize this gauge.")), 'temperature_gauge'],
  1: ['RI Score', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Revenue Integrity (RI) Score"), " shows changes in accuracy over time. The RI Score reflects the overall accuracy of your coding and billing processes, helping you monitor improvements or identify areas needing attention.")), 'ri_score'],
  2: ['RVU Opportunity', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Relative Value Units (RVU)"), " for your practice compared to state-level bell curve distributions. RVUs, help you measure productivity and efficiency by comparing your practice's performance against broader benchmarks.")), 'rvu_opportunity'],
  3: [['Outstanding Revenue Opportunity', '% Revenue Opportunity'], [/*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Outstanding Revenue Opportunity"), " shows the dollar value of potential revenue that your practice is missing out on. Identifying this outstanding revenue opportunity can help focus on areas where improvements lead to significant financial gains.")), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Percentage Revenue Opportunity"), " displays the percentage difference between the revenue you are currently receiving and the potential revenue you could achieve. This metric helps you identify the gap and uncover opportunities to maximize your revenue."))], 'outstanding_revenue_opportunity'],
  4: [['Revenue Breakdown', 'Revenue Reviewed'], [/*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Revenue Breakdown"), " shows the total dollar value of charts that have been upcoded or downcoded. Understanding these adjustments helps you assess the financial impact of coding practices and identify areas for revenue optimization.")), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Revenue Reviewed"), " displays the total amount of revenue associated with charts that have been reviewed. This is calculated by summing the revenue of charts marked as reviewed in the Upload Breakdown tile, helping you track the financial impact of your review process."))], 'revenue_breakdown'],
  5: ['Potential Revenue Breakdown', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Potential Revenue Breakdown"), " calculates potential revenue impact by comparing your practice's coding distribution to state standards. It projects additional revenue based on a set number of charts, helping you identify opportunities for revenue recovery.")), 'potential_revenue_breakdown'],
  6: ['Uploaded Chart Activity', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Uploaded Chart Activity"), " breaks down chart accuracy into more concise categories to help you find actionable insights. Use this information to identify specific issues and enhance the accuracy of your coding and billing processes.")), 'uploaded_chart_activity'],
  7: ['Total Charts', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Total Charts"), " component provides a visual representation of the number of charts within the selected filter date range.")), 'total_charts'],
  8: ['Providers', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Providers Tile"), " lists all providers in your organization, allowing you to rank or sort them based on accuracy or changes in accuracy from the previous time period. This helps you monitor individual provider performance and identify areas for improvement.")), 'providers'],
  9: ['Provider Chart Analytics', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Provider Chart Analytics"), " provides in-depth view of individual provider statistics, including detailed analytics on chart accuracy and performance. Providers can also book education sessions directly from this tile to improve their coding skills and compliance.")), 'providers_chart_analytics'],
  10: ['Upload Breakdown ', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Upload Breakdown"), " details each batch of charts uploaded, sortable by each column header. It can also function as a work queue by using the checkboxes in the far-right column, allowing you to track and manage chart uploads effectively.")), 'upload_breakdown'],
  11: ['Sub Clients', /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("p", null, /*#__PURE__*/React__default["default"].createElement("b", null, "Sub Clients List"), " Displays the list of Sub-clients. For Health System shows hospital, for hospital shows Departments , for Department shows Providers ")), 'sub_clients']
};
const isSwitchableTile = tileId => Array.isArray(ID_TO_TILES_FULL_DETAILS[tileId][0]);
const getDefaultTileName = tileId => isSwitchableTile(tileId) ? ID_TO_TILES_FULL_DETAILS[tileId][0][0] : ID_TO_TILES_FULL_DETAILS[tileId][0];

/* eslint-disable array-callback-return */

// queryParams: {},
//   pathParams: {},
//   body: {},
//   headers: {}

/**
 * @typedef {Object} APIOptions
 * @property {Object} queryParams
 * @property {Object} pathParams
 * @property {Object} body
 * @property {Object} headers
 * @property {string} accessTokenPreferenceKey
 */

axios__default["default"].interceptors.response.use(response => response, error => {
  return Promise.reject(error);
});
const DEFAULT_OPTIONS = {
  queryParams: {},
  pathParams: {},
  body: {},
  headers: {}
};
const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again later';
const _formattedErrorMessage = serverError => {
  if (typeof serverError === 'string') return serverError;
  if (typeof serverError === 'object') {
    if (Object.keys(serverError).length === 0) return;
    const error = serverError?.detail || serverError?.message || {};
    if (Array.isArray(error.message)) {
      return error.message[0].message;
    } else {
      return _formattedErrorMessage(error);
    }
  }
};
const _getErrorMessage = axiosError => {
  const response = axiosError.response;
  const errorMessage = axiosError?.message ?? SOMETHING_WENT_WRONG;
  let serverError = {};
  if (!response) return {
    errorMessage,
    serverError
  };
  serverError = response.data;
  const serverErrorMessage = _formattedErrorMessage(serverError);
  if (!serverErrorMessage) return {
    errorMessage,
    serverError
  };
  if (typeof serverErrorMessage === 'object') {
    return {
      errorMessage,
      serverError
    };
  }
  return {
    errorMessage: serverErrorMessage,
    serverError
  };
};
class APIService {
  constructor({
    accessTokenPreferenceKey
  }) {
    this.accessTokenPreferenceKey = accessTokenPreferenceKey;
  }

  /**
   *
   * @param {string} url
   * @param {APIOptions} options
   * @returns
   */
  get = async (url, options = DEFAULT_OPTIONS) => {
    url = this._prepareURL(url, options);
    const _headers = this._prepareHeaders(options);
    try {
      const response = await axios__default["default"].get(url, {
        headers: _headers
      });
      const data = await _formattedResponse(response);
      return data;
    } catch (e) {
      const {
        errorMessage,
        serverError
      } = _getErrorMessage(e);
      throw new Error(errorMessage, {
        cause: serverError
      });
    }
  };

  /**
   *
   * @param {string} url
   * @param {APIOptions} options
   * @returns
   */
  post = async (url, options = DEFAULT_OPTIONS) => {
    url = this._prepareURL(url, options);
    const _headers = this._prepareHeaders(options);
    if (options.formData && Object.keys(options.formData).length) {
      const data = new FormData();
      Object.keys(options.formData).forEach(item => {
        data.append(item, options.formData[item]);
      });
      options.body = data;
    }
    try {
      const response = await axios__default["default"].post(url, options.body, {
        headers: _headers
      });
      const data = await _formattedResponse(response);
      return data;
    } catch (e) {
      const {
        errorMessage,
        serverError
      } = _getErrorMessage(e);
      throw new Error(errorMessage, {
        cause: serverError
      });
    }
  };

  /**
   *
   * @param {string} url
   * @param {APIOptions} options
   * @returns
   */
  put = async (url, options = DEFAULT_OPTIONS) => {
    url = this._prepareURL(url, options);
    const _headers = this._prepareHeaders(options);
    try {
      if (options.formData && Object.keys(options.formData).length) {
        const data = new FormData();
        Object.keys(options.formData).forEach(item => {
          data.append(item, options.formData[item]);
        });
        options.body = data;
      }
      const response = await axios__default["default"].put(url, options.body, {
        headers: _headers
      });
      const data = await _formattedResponse(response);
      return data;
    } catch (e) {
      const {
        errorMessage,
        serverError
      } = _getErrorMessage(e);
      throw new Error(errorMessage, {
        cause: serverError
      });
    }
  };

  /**
   *
   * @param {string} url
   * @param {APIOptions} options
   * @returns
   */
  patch = async (url, options = DEFAULT_OPTIONS) => {
    url = this._prepareURL(url, options);
    const _headers = this._prepareHeaders(options);
    try {
      if (options.formData && Object.keys(options.formData).length) {
        const data = new FormData();
        Object.keys(options.formData).forEach(item => {
          data.append(item, options.formData[item]);
        });
        options.body = data;
      }
      const response = await axios__default["default"].patch(url, options.body, {
        headers: _headers
      });
      const data = await _formattedResponse(response);
      return data;
    } catch (e) {
      const {
        errorMessage,
        serverError
      } = _getErrorMessage(e);
      throw new Error(errorMessage, {
        cause: serverError
      });
    }
  };

  /**
   *
   * @param {string} url
   * @param {APIOptions} options
   * @returns
   */
  delete = async (url, options = DEFAULT_OPTIONS) => {
    url = this._prepareURL(url, options);
    const _headers = this._prepareHeaders(options);
    try {
      const response = await axios__default["default"].delete(url, {
        headers: _headers
      });
      const data = await _formattedResponse(response);
      return data;
    } catch (e) {
      const {
        errorMessage,
        serverError
      } = _getErrorMessage(e);
      throw new Error(errorMessage, {
        cause: serverError
      });
    }
  };

  /**
   *
   * @param {string} url
   * @param {APIOptions} options
   */
  _prepareURL = (url, options = DEFAULT_OPTIONS) => {
    const {
      queryParams = {},
      pathParams = {}
    } = options;
    Object.entries(pathParams).forEach(([k, v]) => {
      url = url.replaceAll(`:${k}`, v);
    });
    const params = new URLSearchParams(queryParams);
    const qp = params.toString();
    url = url + `?${qp}`;
    return url;
  };
  _prepareHeaders = (options = DEFAULT_OPTIONS) => {
    return {
      Authorization: `${localStorage.getItem(this.accessTokenPreferenceKey)}`,
      ...(options?.headers || {})
    };
  };
}

/**
 *
 * @param {AxiosResponse} response
 */
const _formattedResponse = async response => {
  // if (response.data.data) {
  //   return response.data.data
  // }

  return response.data;
};

exports.APIService = APIService;
exports.AvatarIcon = AvatarIcon;
exports.CQForgotPassword = CQForgotPassword;
exports.CQForgotPasswordMessage = CQForgotPasswordMessage;
exports.CQPagination = CQPagination;
exports.CQReactTable = CQReactTable;
exports.CQResetPassword = CQResetPassword;
exports.CQResetPasswordMessage = CQResetPasswordMessage;
exports.CQSelect = CQSelect;
exports.CQTable = CQTable;
exports.Checkbox = Checkbox;
exports.ConfirmationPopUp = ConfirmationPopUp;
exports.DotMenu = DotMenu;
exports.DotMenuIcon = DotMenuIcon;
exports.DownIcon = DownIcon;
exports.EyeHiddenIcon = EyeHiddenIcon;
exports.EyeIcon = EyeIcon;
exports.FormCQSelect = FormCQSelect;
exports.FormPasswordInput = FormPasswordInput;
exports.FormTextInput = FormTextInput;
exports.Heading = Heading;
exports.ID_TO_TILES_FULL_DETAILS = ID_TO_TILES_FULL_DETAILS;
exports.LeftIcon = LeftIcon;
exports.LockIcon = LockIcon;
exports.MailIcon = MailIcon;
exports.MarkIcon = MarkIcon;
exports.PDFViewer = PDFViewer;
exports.PasswordInput = PasswordInput;
exports.PrimaryButton = PrimaryButton;
exports.RightIcon = RightIcon;
exports.SecondaryButton = SecondaryButton;
exports.SortIcon = SortIcon;
exports.SuccessToastIcon = SuccessToastIcon;
exports.TILES_NAME_TO_ID_MAPPING = TILES_NAME_TO_ID_MAPPING;
exports.TextInput = TextInput;
exports.Topbar = Topbar;
exports.UpIcon = UpIcon;
exports.getDefaultTileName = getDefaultTileName;
exports.isSwitchableTile = isSwitchableTile;
exports.paginationReturnType = paginationReturnType;
exports.strengthChecker = strengthChecker;
exports.useBoolean = useBoolean;
exports.useCQMediaQuery = useCQMediaQuery;
exports.useClickHistorySessionStorage = useClickHistorySessionStorage;
exports.usePagination = usePagination;
exports.useScrollPosition = useScrollPosition;
exports.useTabStorage = useTabStorage;
exports.useToastr = useToastr;
